// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: research.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  AnalyticsType,
  analyticsTypeFromJSON,
  analyticsTypeToJSON,
  ChartTimeframe,
  chartTimeframeFromJSON,
  chartTimeframeToJSON,
  Exchange,
  exchangeFromJSON,
  exchangeToJSON,
} from './common/types'

export const protobufPackage = 'research'

/**
 * Which vertical scale a series belongs on. Absent / UNSPECIFIED means the
 * chart's primary value scale, which is every series shipped before this field
 * existed - so a reader that ignores it is correct for every legacy block.
 * PRICE marks the underlying's own price, carried alongside an analytics
 * measure for context; it is orders of magnitude away from that measure and
 * MUST get its own scale rather than share one.
 */
export enum SeriesAxis {
  SERIES_AXIS_UNSPECIFIED = 0,
  SERIES_AXIS_VALUE = 1,
  SERIES_AXIS_PRICE = 2,
  UNRECOGNIZED = -1,
}

export function seriesAxisFromJSON(object: any): SeriesAxis {
  switch (object) {
    case 0:
    case 'SERIES_AXIS_UNSPECIFIED':
      return SeriesAxis.SERIES_AXIS_UNSPECIFIED
    case 1:
    case 'SERIES_AXIS_VALUE':
      return SeriesAxis.SERIES_AXIS_VALUE
    case 2:
    case 'SERIES_AXIS_PRICE':
      return SeriesAxis.SERIES_AXIS_PRICE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SeriesAxis.UNRECOGNIZED
  }
}

export function seriesAxisToJSON(object: SeriesAxis): string {
  switch (object) {
    case SeriesAxis.SERIES_AXIS_UNSPECIFIED:
      return 'SERIES_AXIS_UNSPECIFIED'
    case SeriesAxis.SERIES_AXIS_VALUE:
      return 'SERIES_AXIS_VALUE'
    case SeriesAxis.SERIES_AXIS_PRICE:
      return 'SERIES_AXIS_PRICE'
    case SeriesAxis.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Chart vocabulary. Additive-only; unknown values must render a generic
 * fallback on the FE. CANDLESTICK/LINE are backed by OHLCV queries;
 * FUNDING_RATE and VOL_TERM_STRUCTURE by the derivatives analytics queries;
 * SKEW / PUT_CALL_RATIO / IV_VS_RV are forward vocabulary (no emitting query
 * yet — reserved so adding one is not a schema change).
 */
export enum ChartType {
  CHART_TYPE_UNSPECIFIED = 0,
  CHART_TYPE_CANDLESTICK = 1,
  CHART_TYPE_LINE = 2,
  CHART_TYPE_FUNDING_RATE = 3,
  CHART_TYPE_VOL_TERM_STRUCTURE = 4,
  CHART_TYPE_SKEW = 5,
  CHART_TYPE_PUT_CALL_RATIO = 6,
  CHART_TYPE_IV_VS_RV = 7,
  UNRECOGNIZED = -1,
}

export function chartTypeFromJSON(object: any): ChartType {
  switch (object) {
    case 0:
    case 'CHART_TYPE_UNSPECIFIED':
      return ChartType.CHART_TYPE_UNSPECIFIED
    case 1:
    case 'CHART_TYPE_CANDLESTICK':
      return ChartType.CHART_TYPE_CANDLESTICK
    case 2:
    case 'CHART_TYPE_LINE':
      return ChartType.CHART_TYPE_LINE
    case 3:
    case 'CHART_TYPE_FUNDING_RATE':
      return ChartType.CHART_TYPE_FUNDING_RATE
    case 4:
    case 'CHART_TYPE_VOL_TERM_STRUCTURE':
      return ChartType.CHART_TYPE_VOL_TERM_STRUCTURE
    case 5:
    case 'CHART_TYPE_SKEW':
      return ChartType.CHART_TYPE_SKEW
    case 6:
    case 'CHART_TYPE_PUT_CALL_RATIO':
      return ChartType.CHART_TYPE_PUT_CALL_RATIO
    case 7:
    case 'CHART_TYPE_IV_VS_RV':
      return ChartType.CHART_TYPE_IV_VS_RV
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ChartType.UNRECOGNIZED
  }
}

export function chartTypeToJSON(object: ChartType): string {
  switch (object) {
    case ChartType.CHART_TYPE_UNSPECIFIED:
      return 'CHART_TYPE_UNSPECIFIED'
    case ChartType.CHART_TYPE_CANDLESTICK:
      return 'CHART_TYPE_CANDLESTICK'
    case ChartType.CHART_TYPE_LINE:
      return 'CHART_TYPE_LINE'
    case ChartType.CHART_TYPE_FUNDING_RATE:
      return 'CHART_TYPE_FUNDING_RATE'
    case ChartType.CHART_TYPE_VOL_TERM_STRUCTURE:
      return 'CHART_TYPE_VOL_TERM_STRUCTURE'
    case ChartType.CHART_TYPE_SKEW:
      return 'CHART_TYPE_SKEW'
    case ChartType.CHART_TYPE_PUT_CALL_RATIO:
      return 'CHART_TYPE_PUT_CALL_RATIO'
    case ChartType.CHART_TYPE_IV_VS_RV:
      return 'CHART_TYPE_IV_VS_RV'
    case ChartType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * The full report payload. Blocks and citations are the render surface; meta
 * carries the typed display scalars.
 *
 * The delivered JSON may carry additional meta keys not defined here
 * (models, cost, data_coverage — service-internal run accounting). They are
 * deliberately uncontracted: read them tolerantly or ignore them. They may be
 * typed here additively later.
 */
export interface ResearchReport {
  meta: ReportMeta | undefined
  blocks: ReportBlock[]
  citations: Citation[]
}

export interface ReportMeta {
  jobId: string
  /** Report flavor, e.g. "shallow_research". */
  useCase: string
  /** Rendered verbatim with the report. */
  disclaimers: string[]
  /** Wall-clock run duration. */
  durationSeconds?: number | undefined
  /**
   * Set ONLY on a Stufe-2 follow-up report: the job_id of the DELIVERED
   * report this one followed up on. Absent on every other producer, so its
   * presence is what identifies a report as a follow-up. The poll envelope
   * carries the same value at its top level; this is the copy that travels
   * with the report body, for a client holding the report alone.
   *
   * A parent link, not a thread: reconstructing a conversation by walking
   * these is a scan, and a first-class follow-up/history surface is planned.
   * Prefer that surface when it lands over hand-rolling chain reconstruction.
   */
  parentJobId?: string | undefined
  /**
   * How big an answer this report IS, set only by the bounded answer engine
   * (use_case "answer"): "paragraph" or "section". Absent on every other
   * producer — a full research report has no size below itself, and a widget
   * explainer's size is the widget's.
   *
   * A STRING, not an enum, and deliberately so while the vocabulary is
   * settling: the router that chooses it is shipping one stage behind this
   * field, and an enum would make every addition to the size vocabulary a
   * schema event for a value the service already treats as an open string.
   * Read an unrecognised value as "some bounded answer" and render it as
   * prose, never as an error. It is a candidate to become an enum once the
   * three sizes have been in production long enough to be believed.
   *
   * It duplicates the poll envelope's own `scope` for the reason
   * `parent_job_id` above duplicates its: this is the copy that travels with
   * the report body, for a client holding the report alone.
   */
  scope?: string | undefined
}

/**
 * One data query the report relied on. Markers are code-assigned in tool-call
 * order ("[1]", "[2]", …) and referenced from each block's sources.
 *
 * `tool` and `source_table` are internal IDENTIFIERS, not user-facing copy:
 * keep them for keys, logs and support. Where `label` is set, show `label`
 * to the trader instead of them.
 */
export interface Citation {
  marker: string
  /** Tool that ran, e.g. "get_ohlcv". Identifier, not display copy. */
  tool: string
  /** Comma-joined table list the query read. Identifier, not display copy. */
  sourceTable: string
  timeRange: TimeRange | undefined
  rowCount: number
  /**
   * Human-readable name of the data source, for display, e.g. "Economic
   * calendar" or "Per-minute order-book data". Filled by the research service
   * in code from its own source registry, never model-written. It NEVER
   * carries an internal tool, table, field or store name; a source with no
   * readable name gets no label rather than an identifier. The frontend
   * shows it wherever a citation is rendered (the source tooltip).
   *
   * SWAPPABLE product copy, NOT contract, in the same way as
   * ResearchJobEvent.label: it can be reworded server-side without a schema
   * change, so never switch on it or use it as a key — use `marker`.
   *
   * Tolerant reader: absent on reports stored before the service filled it,
   * and on any citation without a readable name. Absent means keep the
   * existing fallback rendering; never treat it as an error.
   */
  label?: string | undefined
}

/** Query window, ISO-8601 UTC strings as delivered by the service. */
export interface TimeRange {
  start: string
  end: string
}

/**
 * One report block. Markdown and chart are structurally different render
 * paths, hence a real oneof (see docs/intent-compiler-proto-shape-rules.md;
 * the model-facing emission shape is a separate, flat schema — this union is
 * the DELIVERED contract only).
 * JSON wire note: flattened — {"type": "markdown"|"chart", <fields>}. Do not
 * parse the wire through this wrapper; switch on "type" and parse the flat
 * object with the member type directly (see the file header).
 */
export interface ReportBlock {
  markdown?: MarkdownBlock | undefined
  chart?: ChartBlock | undefined
}

/** A prose section. GitHub-flavored markdown. */
export interface MarkdownBlock {
  /** Short section label, e.g. "Market Structure". */
  section: string
  content: string
  /** Citation markers, code-assigned (never model-written). */
  sources: string[]
}

/**
 * A chart. Assembled in code from a query that already ran; the model
 * contributes only placement and caption. Cross-field invariants are enforced
 * by emitter validation (proto keeps them documentary):
 *   - at least one of reference / series is always present;
 *   - CANDLESTICK always carries a reference (the emitter never
 *     re-aggregates OHLC — resampling is the backend's);
 *   - a preview (is_preview = true) always carries a reference to hydrate
 *     from, holds <= 500 points, and only exists at intervals the backend
 *     serves natively from the same source views (60 / 3600 / 86400 s).
 */
export interface ChartBlock {
  /**
   * Additive capability generation, for renderer negotiation only; currently
   * 1. Existing fields never change semantics (see the file header) — a bump
   * means "new additive surface exists", never "old fields mean something
   * else".
   */
  schemaVersion: number
  /** Section label this chart belongs under, e.g. "Market Structure". */
  section: string
  /** Short model-authored label; its numbers come only from `aggregates`. */
  caption: string
  /**
   * Selects the renderer. Serialized as the member NAME string (canonical
   * proto3-JSON enum form, e.g. "CHART_TYPE_CANDLESTICK" — same convention as
   * `exchange`). Unknown values: render a generic fallback.
   */
  chartType: ChartType
  /**
   * Set when the FE can hydrate this exact series itself via the chartData
   * call the chart widget already uses (today: OHLCV candles/lines).
   */
  reference: ChartReference | undefined
  /**
   * Inline points: the full series for analytics charts (no FE feed exists),
   * or a gated preview for price charts (paint first, hydrate via reference).
   */
  series: ChartSeries[]
  /** Declared shape of `series`, for a cheap declared-vs-received check. */
  integrity: ChartIntegrity | undefined
  /**
   * True when `series` is a preview to be replaced by the reference fetch.
   * A preview is NEVER downsampled or re-bucketed: it is exactly the queried
   * bars (<= 500), at the same interval and from the same source views as
   * the hydrate — treat it as exact data, not an approximation.
   */
  isPreview: boolean
  /** True if the backing query hit its row LIMIT — the series is partial. */
  truncated: boolean
  /**
   * Computed in code from the exact rendered series; the caption and the
   * prose next to the chart are written against these values. OPEN, additive
   * key vocabulary — tolerate unknown keys and absent keys. Today:
   *   - always: rows, window_start, window_end (the window bounds are
   *     ISO-8601 UTC strings; every other value is a plain decimal string);
   *   - when numeric values exist: min, max (candles: min of lows / max of
   *     highs — the wicks);
   *   - single-series charts only: first, last, change_abs, and (when
   *     first != 0) change_pct;
   *   - multi-series charts only: series (the series count).
   * rows here is display-oriented; ChartIntegrity.rows is the same count as
   * an int32 for the receiver-side check — they never disagree.
   */
  aggregates: { [key: string]: string }
  /** Citation markers, code-assigned. */
  sources: string[]
}

export interface ChartBlock_AggregatesEntry {
  key: string
  value: string
}

/**
 * A descriptor the FE resolves itself via chartData. Every field is read off
 * the backing query's validated parameters, never model-written — the window
 * the report text analyzed IS the window the chart renders.
 */
export interface ChartReference {
  /** Venue-native symbol, e.g. "BTC-PERPETUAL". */
  symbol: string
  /**
   * The emitter only produces venues the FE round-trips today (BINANCE,
   * BYBIT, DERIBIT, HYPERLIQUID, UPBIT); treat anything else as invalid
   * rather than defaulting.
   */
  exchange: Exchange
  /** Same grid as ChartDataRequest.timeframe (enum value = seconds). */
  intervalSeconds: ChartTimeframe
  /**
   * Window start, unix SECONDS (not ms — see the file header's time-encoding
   * note) — maps onto ChartDataRequest.from. Always set: a report chart
   * always has a bounded window, and 0 is never a valid value.
   */
  fromTs: string
  /** Window end, unix SECONDS — maps onto ChartDataRequest.to. Always set. */
  toTs: string
  /**
   * Always false for report charts: render exactly [from_ts, to_ts]; no
   * chartDataStream live bar, which would drift off the adjacent prose.
   */
  live: boolean
  /**
   * Feed the reference resolves against. Constant "oems.chart_data" today;
   * an evolution hook, not a switch.
   */
  feed: string
}

/** One named line/candle sequence within a chart. */
export interface ChartSeries {
  /** Display label, e.g. "BTC-PERPETUAL funding" or "BTC atm 30d". */
  label: string
  points: ChartPoint[]
  axis: SeriesAxis
}

/**
 * One point. All values are decimal strings (see file header); `t_ms` is a
 * string for the same reason and to match the FE's existing string
 * millisecond-timestamp props.
 */
export interface ChartPoint {
  /**
   * Epoch MILLISECONDS as a decimal string (ChartReference windows are unix
   * seconds — multiply those by 1000 before comparing).
   */
  tMs: string
  /** Line-series value. Absent = gap; never interpolate. */
  v?: string | undefined
  /** Candle values; populated for candle series only. */
  o?: string | undefined
  h?: string | undefined
  l?: string | undefined
  c?: string | undefined
}

/**
 * Declared shape of the inline series so the receiver can detect truncation
 * at the storage/transport boundary (the model never touches the array, so
 * transcription corruption is designed out). rows/first/last are the
 * load-bearing three-line check; checksum is optional defense-in-depth and
 * may be skipped.
 */
export interface ChartIntegrity {
  rows: number
  /** First point's t_ms. */
  first?: string | undefined
  /** Last point's t_ms. */
  last?: string | undefined
  /**
   * Optional: sha256 over one "t_ms|v|o|h|l|c" line per point (absent fields
   * render as EMPTY strings, so a line-series point hashes as "t|v||||"),
   * first 16 hex chars. Not emitted today.
   */
  checksum?: string | undefined
}

/**
 * The poll response. Polled repeatedly for one job_id until `phase` is
 * terminal (DELIVERED, FAILED or KILLED).
 *
 * Two keys the service returns are deliberately NOT here — "cost" and
 * "error"; see the file header for why. Read them off the raw JSON if you
 * need them. Everything else the poll returns is typed below, including the
 * four fields the bounded answer engine added (kind, scope, error_code,
 * recovery) and the retry signal (retryable).
 */
export interface ResearchJobStatus {
  /** The polled job's own id — echoed back, so a response identifies itself. */
  jobId: string
  phase: ResearchJobStatus_Phase
  /**
   * Set on a Stufe-2 follow-up job: the parent report's job_id. Mirrors
   * ReportMeta.parent_job_id, and is present on EVERY phase of the follow-up
   * job — including before its report exists, which is why it is here and not
   * only on the report body. Also set on a "backtest_parse" job that edits an
   * earlier backtest, and on the "backtest" job confirmed from its card: the
   * earlier backtest run's job_id. Branch on `kind` for which it is.
   */
  parentJobId?: string | undefined
  /**
   * The progress timeline, seq-ordered. Absent or empty is normal: both event
   * kinds are flag-gated, a job may have recorded none, and read-time
   * filtering can empty a list that was written non-empty. Never treat an
   * empty timeline as an error or as evidence of a stalled job.
   */
  events: ResearchJobEvent[]
  /**
   * The delivered report. Set on DELIVERED and only on DELIVERED — the
   * report item does not exist before then. Same envelope the widget
   * explainer delivers (ExplainWidgetResponse.report).
   */
  report: ResearchReport | undefined
  /**
   * WHICH PRODUCER made this job: "research", "widget", "followup",
   * "answer", "backtest_parse" (reads a backtest out of a chat message and
   * serves its card, see `proposal`) or "backtest" (the confirmed run,
   * rendered as a report). Present on EVERY phase, so a client knows how to
   * render the result before there is one — a bounded answer belongs in the
   * conversation as a bubble, a full report in the report card, and the
   * difference has to be knowable while the job is still RUNNING.
   *
   * A STRING and an OPEN vocabulary: a new producer must not be a schema
   * event for a client that only branches on the two it renders. Treat an
   * unrecognised value the way you would treat "research".
   */
  kind?: string | undefined
  /**
   * How big an answer was asked for, on a job whose `kind` is "answer":
   * "paragraph" or "section". Absent on every other kind. Mirrors
   * ReportMeta.scope; see that field for why it is a string.
   */
  scope?: string | undefined
  /**
   * WHY a FAILED or KILLED job failed, as a stable value a client can branch
   * on. The untyped "error" key beside it is the SENTENCE a user reads, and it
   * is deliberately reworded without a schema round-trip — so a client that
   * branches on prose is one rewording away from taking the wrong arm. This is
   * what to branch on instead.
   *
   * Three vocabularies, one per producer family. An "answer" job carries only
   * its own; a backtest job carries its own or, outside its own steps, a
   * stored cause:
   *
   *   - kind "answer": six values from the bounded answer engine,
   *     "not_grounded" (nothing was found to answer FROM — the one value with
   *     a defined affordance, see `recovery`), "plan_rejected",
   *     "parent_unavailable", "engine_error", "budget", "timeout". An answer
   *     job that failed without one of these carries no code.
   *   - every other kind ("research", "widget", "followup", and a backtest
   *     kind as below), on a FAILED job only: the stored failure cause, one
   *     of "timeout", "data_source", "no_data", "analysis", "oversize",
   *     "persist", "engine", "not_started", "interrupted", "worker_died".
   *     Diagnostic, for copy selection and support; the retry decision is
   *     `retryable`, not a client-side table over these. "interrupted" is a
   *     run a deploy or drain took; "worker_died" is a run whose worker
   *     crashed or was killed with no deploy in between.
   *   - kind "backtest_parse" or "backtest", on a FAILED job, when the
   *     backtest's own step failed: its own codes. "backtest_parse_refused",
   *     "backtest_parse_truncated" and "backtest_parse_invalid" mean no card
   *     could be drafted; "backtest_unsupported", "backtest_data",
   *     "backtest_data_gap", "backtest_timeout" and "backtest_busy" mean the
   *     run did not complete; "backtest_failed" is the catch-all on either
   *     kind. A failure outside those steps (the job's own timeout, a
   *     market-data outage, a deploy or drain, a crashed worker, a store
   *     fault, a job that never started) carries a stored cause instead. As
   *     above, retry on `retryable`, not on these.
   *
   * Plus "unsupported_kind" on any kind, written when a queued job names a
   * producer the worker cannot run. Absent on a job that has not failed, and
   * absent on a failed job recorded before its producer wrote codes —
   * absence is not an error, it means "read the sentence".
   *
   * OPEN, like `kind`: render an unrecognised code as a generic failure.
   */
  errorCode?: string | undefined
  /**
   * What to POST to escalate this failed answer to a full research run. Set
   * only on a FAILED or KILLED job whose `kind` is "answer".
   *
   * IT EXISTS BECAUSE THE OBVIOUS RECOVERY IS WRONG. A failed job is never a
   * follow-up target (eligibility requires DELIVERED, correctly), so a client
   * offering "run the full report" without this would escalate against
   * whatever artifact succeeded EARLIER — answering a different question than
   * the one that just failed. This binds the recovery to the failed question.
   */
  recovery?: RecoveryRequest | undefined
  /**
   * Whether re-sending the same request can plausibly succeed. THE field a
   * retry button branches on: show the button when this is true, and only
   * then. Never derive it from `error_code` or from the "error" sentence.
   *
   * Set on a FAILED job only, on every kind; absent on every other phase.
   * KILLED (a guard stopped a paid run the same request would most likely
   * hit again) and CANCELLED (the user's own stop) never carry it.
   *
   * true: the failure was transient, e.g. a timeout, a market-data or
   * analysis-service outage, a deploy interrupting the run, a store fault,
   * or a queue that was briefly unavailable.
   * false: a re-send returns the same failure, e.g. no data for the window
   * or series asked for, a report too large to store, a credential or
   * permission fault, a request the engine cannot plan, or an unclassified
   * defect. A failed "answer" job offers `recovery` instead.
   *
   * Absent on a FAILED job means NO SIGNAL (the job was recorded before this
   * field existed): treat it like false and show no button. Decided by the
   * service where the failure happened, not from a table over causes.
   */
  retryable?: boolean | undefined
  /**
   * A backtest card, on a DELIVERED job whose `kind` is "backtest_parse",
   * when the message read as a strategy this version can run; `backtest` is
   * set on it. Absent otherwise: then render `report`, which says why the
   * message did not read as a strategy or, for an unconfirmed card past its
   * 30-day retention, is that card as markdown. Render the card
   * INSTEAD of `report`, which is the same card as markdown for a client that
   * cannot render it; never both. Unlike the rest of the poll, this object
   * carries JSON null: `window`, `degraded` and `answer_scope` as on a
   * classify card, and `value`, `min`, `max` and `unit` on an editable field.
   * Treat null and absent alike.
   */
  proposal: Proposal | undefined
}

/**
 * Job lifecycle state. An ENUM, and therefore a closed set: adding a state
 * is deliberately a schema event, unlike the open progress vocabularies on
 * ResearchJobEvent (see the file header's convention rule). Serialized as
 * the member NAME string, e.g. "DELIVERED".
 *
 * NOT to be confused with ResearchJobEvent.phase, which is a progress
 * MILESTONE inside a RUNNING job ("gathering", "writing"). Different
 * vocabularies, different lifetimes, same English word: this one is the
 * job's state, that one is the loading bar's step.
 */
export enum ResearchJobStatus_Phase {
  /**
   * PHASE_UNSPECIFIED - Never emitted by the service; present because proto3 requires a zero
   * member. Treat it as a malformed response, not a state.
   */
  PHASE_UNSPECIFIED = 0,
  /** PENDING - Accepted, not yet started. */
  PENDING = 1,
  /** RUNNING - Executing. The only phase that produces new progress events. */
  RUNNING = 2,
  /** DELIVERED - Terminal, success: `report` is set. */
  DELIVERED = 3,
  /** FAILED - Terminal, failure: the untyped "error" key carries user-facing copy. */
  FAILED = 4,
  /** KILLED - Terminal, stopped by a guard (e.g. budget). Same "error" treatment. */
  KILLED = 5,
  /**
   * CANCELLED - Terminal, stopped BY THE USER who started it (the FE stop button).
   * Deliberately NOT folded into KILLED: KILLED means a GUARD stopped the
   * run - a budget cap, something the user did not choose - whereas this
   * means the run was fine and the person watching it changed their mind.
   * Folding them would leave a client separating "you stopped this" from
   * "we stopped this" by matching user-facing error prose.
   */
  CANCELLED = 6,
  UNRECOGNIZED = -1,
}

export function researchJobStatus_PhaseFromJSON(object: any): ResearchJobStatus_Phase {
  switch (object) {
    case 0:
    case 'PHASE_UNSPECIFIED':
      return ResearchJobStatus_Phase.PHASE_UNSPECIFIED
    case 1:
    case 'PENDING':
      return ResearchJobStatus_Phase.PENDING
    case 2:
    case 'RUNNING':
      return ResearchJobStatus_Phase.RUNNING
    case 3:
    case 'DELIVERED':
      return ResearchJobStatus_Phase.DELIVERED
    case 4:
    case 'FAILED':
      return ResearchJobStatus_Phase.FAILED
    case 5:
    case 'KILLED':
      return ResearchJobStatus_Phase.KILLED
    case 6:
    case 'CANCELLED':
      return ResearchJobStatus_Phase.CANCELLED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ResearchJobStatus_Phase.UNRECOGNIZED
  }
}

export function researchJobStatus_PhaseToJSON(object: ResearchJobStatus_Phase): string {
  switch (object) {
    case ResearchJobStatus_Phase.PHASE_UNSPECIFIED:
      return 'PHASE_UNSPECIFIED'
    case ResearchJobStatus_Phase.PENDING:
      return 'PENDING'
    case ResearchJobStatus_Phase.RUNNING:
      return 'RUNNING'
    case ResearchJobStatus_Phase.DELIVERED:
      return 'DELIVERED'
    case ResearchJobStatus_Phase.FAILED:
      return 'FAILED'
    case ResearchJobStatus_Phase.KILLED:
      return 'KILLED'
    case ResearchJobStatus_Phase.CANCELLED:
      return 'CANCELLED'
    case ResearchJobStatus_Phase.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * The escalation a client can offer after a bounded answer fails: the same
 * question, its parent if it had one, at full research scope.
 *
 * Every field is a value the server already holds on the failed job; nothing
 * here is computed and nothing is a new entity. A client POSTs it to
 * /research verbatim.
 */
export interface RecoveryRequest {
  /** The question that failed, exactly as the user asked it. */
  question: string
  /**
   * The artifact the failed answer was built on, when it had one. Absent on a
   * first, parentless answer — nothing was lost, because nothing existed.
   */
  parentJobId?: string | undefined
  /**
   * Always "full". Carried rather than assumed so the escalation is explicit
   * in the payload a client sends, and so a future third size does not need a
   * client change to be expressible.
   */
  scope: string
  /**
   * The conversation to keep the escalation on, when the failed answer had
   * one.
   */
  threadId?: string | undefined
}

/**
 * One entry of the poll's "events" list.
 *
 * FLAT, with a discriminator field — deliberately NOT the flattened oneof
 * ReportBlock uses. A oneof fits ReportBlock because its members PARTITION
 * every field: each block field belongs to exactly one member. Here they do
 * not — `seq` and `ts_ms` belong to EVERY event while the rest split by kind,
 * so a oneof would have to either duplicate the shared pair into both members
 * or leave a wrapper whose flattening rules differ from ReportBlock's. This
 * message matches the wire 1:1 instead — read `kind`, then read that kind's
 * fields.
 *
 * Kind-specific fields are ABSENT on the other kind rather than zero-valued,
 * hence `optional`.
 *
 * String vocabularies, NOT proto enums: `kind`, `status`, `phase`, `step`
 * and `group` travel as the service's own lowercase literals ("phase",
 * "running", "interpreting", "group_done", "price"), so this file's
 * enum-member-name-string convention (ChartType, Exchange) deliberately does
 * NOT apply to them — typing them as enums would misdescribe the wire. All
 * are open and grow additively; treat an unrecognized value as a generic
 * step, never as an error.
 */
export interface ResearchJobEvent {
  /**
   * Ordering token, unique and monotonic within one job — NOT a dense index.
   * All kinds share this counter and the service filters by kind at read
   * time, so a delivered list has gaps and tool events are not 1..N. Sort by
   * it; never index by it. See the file header.
   */
  seq: number
  /**
   * Emission time, epoch MILLISECONDS as a JSON number (run telemetry, so a
   * number — not the decimal string ChartPoint.t_ms uses; see the header's
   * time-encoding note). Ordering is `seq`'s job, not this field's:
   * timestamps can tie.
   */
  tsMs: string
  /**
   * Kind discriminator: "tool", "phase" or "step". Every event the service
   * WRITES now sets it explicitly. An unrecognized kind is a generic step:
   * render its `label` if it has one, never error on it.
   *
   * Absent or empty still means "tool", and handling that is NOT optional
   * defensiveness: events recorded before the explicit-kind change were stored
   * without the key, the jobs table has no TTL, and the poll returns stored
   * events verbatim. So a job created before that change returns kind-less
   * tool events TODAY, and will for as long as it stays pollable. A reader
   * that treats only "tool" as a tool event silently renders an empty
   * timeline for every one of those jobs.
   */
  kind: string
  /**
   * The charged tool-call number this event belongs to. PAIR a "running"
   * event with its terminal "complete"/"failed" by this value — never by
   * adjacency or seq arithmetic, since an individual event can be dropped.
   * Treat the latest per-call status as current, but see the "truncated"
   * carve-out on `status`: that one record is NOT a per-call status.
   */
  call?: number | undefined
  /** The tool that ran, e.g. "get_ohlcv". */
  tool?: string | undefined
  /**
   * PER-CALL status: "running" when the call is charged, then "complete" or
   * "failed". These three resolve per `call` — latest one wins.
   *
   * "truncated" is NOT one of them. It is a STREAM-LEVEL marker, emitted once
   * when a run exceeds the per-run tool-event cap; after it, NO further TOOL
   * events arrive for that job (phase events deliberately continue — it ends
   * the tool stream, not the run's narrative). It carries the `call`/`tool`
   * of the emit that tripped it so every record maps uniformly, but that call
   * may well go on to complete. A consumer MUST EXCLUDE "truncated" from
   * per-call status resolution: folding it in marks a call truncated that
   * merely happened to be the one at the boundary.
   */
  status?: string | undefined
  /**
   * Coarse call parameters, on "running" only. A fixed whitelist of identity
   * and window keys (symbol, currency, exchange, family, tier, start, end),
   * each stringified and truncated to 48 characters — enough to label a
   * progress step, never fetched data and never free text. Absent when the
   * call carried none of them. The key set is open: tolerate unknown keys.
   */
  params: { [key: string]: string }
  /**
   * On "failed" only: the exception CLASS name (e.g. "ToolQueryFailed", or
   * "CancelledError" when the run died mid-call), truncated to 48 characters.
   * Deliberately never the exception message, which can embed SQL or table
   * detail. A diagnostic label — not user-facing copy.
   */
  reason?: string | undefined
  /**
   * WHO issued the call: the service's own analyst id ("market_structure",
   * "derivatives_vol", "news_events"). Present on EVERY tool event a report
   * run produces, including the stream-level "truncated" marker, so the whole
   * timeline maps uniformly.
   *
   * The SAME "truncated" carve-out `status` documents for `call`/`tool` applies
   * here, and it is the one place this field can mislead: the marker carries
   * the analyst of whichever emit happened to trip the per-run cap, but the
   * truncation is RUN-WIDE — every analyst's tool stream ends there, not that
   * one's. A consumer grouping the timeline by analyst MUST render the marker
   * as a stream-level event rather than filing it under the analyst it names,
   * or one analyst appears to have stopped while the others carried on.
   *
   * ABSENT — not empty — where the producer genuinely has no analyst: the
   * widget-explainer and follow-up paths run no analysts at all, so they emit
   * tool events with this field unset rather than with a placeholder. A reader
   * must handle the absent case; it is a normal shape, not a degraded one.
   *
   * An OPEN service-owned vocabulary, and a plain string for exactly the
   * reason `kind`/`status`/`phase` are (see the header): the analyst roster is
   * this service's own and grows without a schema round-trip. Two analysts can
   * share a tool NAME, which is why `tool` alone does not identify the caller
   * and this field exists — attributing per-tool progress by tool name breaks
   * the moment a roster binds one spec to more than one analyst.
   *
   * A code-owned identifier, never model output and never user text, so it
   * carries no more than `tool` already does. Truncated to 48 characters like
   * every other string on this message.
   */
  analyst?: string | undefined
  /**
   * The display GROUP an event belongs to: "price", "flow", "derivatives",
   * "news", "market". A code-owned key, so a consumer can file reads and
   * done lines under one area without mapping internal analyst ids. On a
   * tool event it is the group of the issuing `analyst`, on every transition;
   * on a step event it names the group the line is about. ABSENT where there
   * is no group: the widget-explainer and follow-up paths, steps about the
   * whole run (planning, synthesis), and the stream-level "truncated" marker,
   * which is run-wide and belongs to no group.
   *
   * Groups are coarser than analysts on purpose: several analysts can share
   * one group, and they finish as one group. An OPEN vocabulary, like
   * `analyst`. Switch on it to arrange a view; render `label` for the words.
   */
  group?: string | undefined
  /**
   * The STABLE KEY of a step line, the finer code-owned lines between phases:
   *   - "planning": the analysis areas the run will cover, right after the
   *     run chose its analysts.
   *   - "group_done": one `group` finished its analysis (carries `group`).
   *     Fires when the LAST in-flight analyst of that group returns, and
   *     only if one of them produced analysis.
   *   - "synthesizing": the analysts are done and the report is being put
   *     together. It is NOT a promise of a report: the run's health checks
   *     come after it, and "writing" (a phase) still follows them.
   * A run can dispatch analysts over several rounds, so "group_done" and
   * "synthesizing" can each REPEAT (a few times at most): the latest one is
   * current. Steps carry no ordering rule beyond `seq`: group lines arrive in
   * whatever order groups finish, and a step may be skipped. An OPEN vocabulary; treat an unknown step as a
   * generic line and render its `label`.
   */
  step?: string | undefined
  /**
   * The STABLE KEY to switch on: "interpreting", "gathering", "analyzing",
   * "writing". Renaming one is a contract break; adding one is additive.
   *
   * A run SKIPS any phase it cannot honestly claim, so NEVER assume the full
   * set and never assume a fixed stride — only that seq increases. Notably
   * the full-report path never emits "analyzing": gathering, analysis and
   * drafting all happen inside one opaque model call, so there is no instant
   * at which "analyzing" is true and "gathering" has stopped being true. A
   * run that charges no tool call likewise skips "gathering".
   */
  phase?: string | undefined
  /**
   * User-facing copy for this event. On a phase, the copy for `phase`
   * ("gathering market data"); on a step, the copy for `step` ("planning
   * price and news analysis", "price analysis done", "putting it together");
   * on a tool "running" event, the data set being read ("BTC price candle
   * data, last 7 days"). Absent on "complete"/"failed"/"truncated" tool
   * events, so the latest labelled event is the current line.
   *
   * Built in code from fixed tables and validated call parameters, never
   * model output. SWAPPABLE product copy, NOT contract: it can be reworded
   * server-side without a schema change, so never switch on it. Render
   * `label` to use the service's wording; switch on `phase` / `step` to
   * supply your own. Up to 96 characters.
   */
  label?: string | undefined
}

export interface ResearchJobEvent_ParamsEntry {
  key: string
  value: string
}

export interface WidgetContext {
  /**
   * Which metric view the button was clicked on. Reuses the same enum the
   * frontend already sends to OEMS on getAnalyticRange, so the button and the
   * chart it sits on name the metric identically — no second vocabulary.
   * FE source: state/widget-instances.ts → dataWidgetAnalyticsTypeAtomFamily(cardId)
   * Prompt use: selects the server-side fetch recipe AND renders the metric's
   * human label into the prompt. REQUIRED — ANALYTICS_TYPE_UNSPECIFIED is
   * rejected, as is any metric the service has no recipe for.
   */
  metric: AnalyticsType
  /**
   * Base currency of the analytics series. These are currency-keyed series,
   * not instrument-keyed — "BTC", not "BTC-PERPETUAL".
   * FE source: the widget's active option ticker, reduced to its base asset.
   * Prompt use: rendered as the asset under discussion. REQUIRED, non-empty.
   */
  currency: string
  /**
   * The venue the analytics are computed for. An enum, not the venue's string
   * literal, so it round-trips with every sibling message (ChartReference,
   * GetAnalyticRangeRequest).
   * FE source: analytics.types.ts → DEFAULT_AMBERDATA_EXCHANGE (today the
   * widget hardcodes EXCHANGE_DERIBIT; sending it explicitly means the
   * contract does not have to change when that stops being true).
   * Prompt use: rendered as the exchange. REQUIRED — EXCHANGE_UNSPECIFIED is
   * rejected rather than defaulted to Deribit.
   */
  exchange: Exchange
  /**
   * Displayed window start, Unix epoch MILLISECONDS — the same encoding
   * GetAnalyticRangeRequest.from uses, so the frontend's existing date-picker
   * plumbing carries over unchanged. (Note this file's other window type,
   * ChartReference.from_ts/to_ts, is epoch SECONDS — do not mix them.)
   * FE source: dataWidgetFromDateAtomFamily(cardId), or the trailing-7d
   * default when the picker is untouched.
   * Prompt use: bounds the fetch and is rendered as the period under review.
   * REQUIRED.
   */
  rangeStartMs: string
  /**
   * Displayed window end, Unix epoch MILLISECONDS. REQUIRED, and must be
   * strictly greater than range_start_ms — a zero-width or reversed window is
   * rejected, never silently widened.
   * FE source: dataWidgetToDateAtomFamily(cardId), or the trailing-7d default.
   */
  rangeEndMs: string
}

/**
 * POST /research/widget body. Deliberately carries nothing but the widget
 * context: the default prompt is a server-side constant, so there is no field
 * for a client to put prompt text in and the request is structurally incapable
 * of carrying user free text. A later free-text arm adds a field here; until
 * then its absence is the guarantee.
 */
export interface ExplainWidgetRequest {
  widget: WidgetContext | undefined
  /**
   * Optional Arm-2 free-text question. Absent = Arm 1 (default query). Gated server-side
   * by widget_freetext_enabled; the AI layer rejects it loudly while that flag is off.
   */
  userQuery?: string | undefined
}

/**
 * Delivered report, identical in shape to the polled research report — the
 * widget explainer is a second producer of the same envelope, not a second
 * envelope. Reaches the client through the existing
 * GET /research/{job_id} poll; this message names the contract.
 */
export interface ExplainWidgetResponse {
  report: ResearchReport | undefined
}

/** POST /research/classify body. The service rejects unknown keys (422). */
export interface ClassifyRequest {
  /**
   * The user's message, untrusted. At most 4000 characters as sent (measured
   * before trimming); blank after trimming is a 422. REQUIRED.
   */
  message: string
  /**
   * Which consumer sent it: "web" or "telegram", any other value is a 422.
   * Reaches the service's log line only; never changes behaviour. A plain
   * string carrying the service's literal (this file's open-string
   * convention), not an enum.
   */
  client?: string | undefined
  /**
   * The user's explicit "run it anyway" / Deep Research toggle. Can only
   * promote to FULL_RESEARCH. Absent = false.
   */
  userOptIn: boolean
  /**
   * Shadow-sampling hint, one-directional: false opts this request out of
   * refusal sampling, true merely leaves it eligible. Absent = TRUE (hence
   * optional: absent and false mean different things).
   */
  shadowEligible?: boolean | undefined
  /**
   * The conversation to continue. Absent on the first message: the service
   * opens a thread and returns its id in ClassifyResponse.thread_id. 1 to 64
   * characters. A 422 while the service's chat flow is off.
   */
  threadId?: string | undefined
  /**
   * THE REPORT LENGTH the user chose: "paragraph" (TLDR), "section"
   * (Compact) or "full" (Extensive). Any other value is a 422. Absent, the
   * route sizes the run as it always has. Present, it sizes the run this call
   * starts (FULL_RESEARCH and FOLLOWUP_ON_EXISTING); DIRECT_ANSWER, CLARIFY and
   * REFUSE start nothing and ignore it. "paragraph"/"section" on a message
   * over 1000 characters is a 422, and so is the field while the service's
   * chat flow is off. Same vocabulary as ReportMeta.scope and a string for
   * the same reason.
   */
  scope?: string | undefined
}

/** The 200 body. */
export interface ClassifyResponse {
  route: ClassifyResponse_Route
  /**
   * DIAGNOSTIC: the router's own confidence in the chosen route (1.0 where
   * the deciding model exposes no probabilities). Never branch on it.
   */
  confidence: number
  /** "<model>/<prompt version>" of the router call. */
  modelVersion: string
  /**
   * How the route was reached, e.g. "CLASSIFIER_RESEARCH", "USER_OPT_IN",
   * "THREAD_UNAVAILABLE", "PROPOSAL_REUSED", "CLARIFY_ALREADY_ASKED",
   * "ANSWER_NOT_GROUNDED", "CONFIRM_STEP_SKIPPED". UPPER_SNAKE codes owned by
   * the service, a trace for support and telemetry, never prose. Closed on
   * the service but grown without a schema change, so a plain string list
   * here: never branch on it, tolerate unknown codes.
   */
  reasonCodes: string[]
  requestId: string
  /** First-party copy to render. Set on REFUSE and CLARIFY; null otherwise. */
  userMessage?: string | undefined
  /** Set on FOLLOWUP_ON_EXISTING only; null otherwise. */
  followup: ClassifyFollowup | undefined
  /** Set on CLARIFY only; null otherwise. */
  clarify: ClassifyClarify | undefined
  /**
   * The id to send as ClassifyRequest.thread_id on the next message. Null
   * while the chat flow is off or when no thread could be opened
   * (THREAD_UNAVAILABLE in reason_codes).
   */
  threadId?: string | undefined
  /**
   * The confirm card. Set on FULL_RESEARCH and FOLLOWUP_ON_EXISTING only, and
   * only when its turn was stored. Null on the other routes, when the run
   * already started (`run` set), while the chat flow is off, when the card
   * could not be stored or a retry found it already confirmed
   * (THREAD_UNAVAILABLE), and when it was already spent.
   */
  proposal: Proposal | undefined
  /** The inline answer. Set on DIRECT_ANSWER only; null otherwise. */
  answer: DirectAnswer | undefined
  /**
   * Set when this response itself started the run (the service skips the
   * confirm step). When `run` is set, `proposal` is null; the converse does
   * not hold (see `proposal`). On BACKTEST it is always set and names the
   * card's parse job, not the backtest, which starts only from a tap on the
   * card. A retry, or a "yes" to a card still pending, gets the same job_id
   * back with PROPOSAL_REUSED and starts nothing.
   */
  run: ClassifyRun | undefined
  /**
   * The stored seq of the reply turn this response wrote. Set on
   * DIRECT_ANSWER, CLARIFY and REFUSE when that turn landed on a thread; with
   * `thread_id` it names a text answer a client flags. Null otherwise.
   */
  turnSeq?: number | undefined
}

/**
 * Where the message goes. A CLOSED set (pinned by the service's tests;
 * adding a route is a schema event), so an enum, and on the wire the member
 * NAME exactly as below, e.g. "FULL_RESEARCH". Treat an unrecognised value
 * as FULL_RESEARCH. Depending on the parser an unknown route arrives as
 * ROUTE_UNSPECIFIED (ignore-unknown parsing), UNRECOGNIZED (ts-proto) or a
 * parse error: map all three to FULL_RESEARCH.
 */
export enum ClassifyResponse_Route {
  /** ROUTE_UNSPECIFIED - Never sent. Present because proto3 requires a zero member. */
  ROUTE_UNSPECIFIED = 0,
  /**
   * FULL_RESEARCH - POST /research (or the run already started, see `run`). The default
   * and the fail-open target.
   */
  FULL_RESEARCH = 1,
  /**
   * FOLLOWUP_ON_EXISTING - About a report this user already has; `followup` names it. The client
   * picks the follow-up tier.
   */
  FOLLOWUP_ON_EXISTING = 2,
  /**
   * CLARIFY - Two or more topics, none chosen. Render `user_message`; `clarify`
   * options are hints, the user types their own answer on the same thread.
   */
  CLARIFY = 3,
  /**
   * REFUSE - Nothing a market-data run could answer. Render `user_message`; "run it
   * anyway" re-sends with user_opt_in = true.
   */
  REFUSE = 4,
  /** DIRECT_ANSWER - Answered inline; `answer` carries it. Nothing was started. */
  DIRECT_ANSWER = 5,
  /**
   * BACKTEST - A backtest request. `run` names a parse job (kind "backtest_parse")
   * that reads the strategy out of the message and simulates nothing; its
   * DELIVERED poll carries the card as ResearchJobStatus.proposal. Poll it
   * like any job. `proposal` is null here.
   */
  BACKTEST = 6,
  UNRECOGNIZED = -1,
}

export function classifyResponse_RouteFromJSON(object: any): ClassifyResponse_Route {
  switch (object) {
    case 0:
    case 'ROUTE_UNSPECIFIED':
      return ClassifyResponse_Route.ROUTE_UNSPECIFIED
    case 1:
    case 'FULL_RESEARCH':
      return ClassifyResponse_Route.FULL_RESEARCH
    case 2:
    case 'FOLLOWUP_ON_EXISTING':
      return ClassifyResponse_Route.FOLLOWUP_ON_EXISTING
    case 3:
    case 'CLARIFY':
      return ClassifyResponse_Route.CLARIFY
    case 4:
    case 'REFUSE':
      return ClassifyResponse_Route.REFUSE
    case 5:
    case 'DIRECT_ANSWER':
      return ClassifyResponse_Route.DIRECT_ANSWER
    case 6:
    case 'BACKTEST':
      return ClassifyResponse_Route.BACKTEST
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClassifyResponse_Route.UNRECOGNIZED
  }
}

export function classifyResponse_RouteToJSON(object: ClassifyResponse_Route): string {
  switch (object) {
    case ClassifyResponse_Route.ROUTE_UNSPECIFIED:
      return 'ROUTE_UNSPECIFIED'
    case ClassifyResponse_Route.FULL_RESEARCH:
      return 'FULL_RESEARCH'
    case ClassifyResponse_Route.FOLLOWUP_ON_EXISTING:
      return 'FOLLOWUP_ON_EXISTING'
    case ClassifyResponse_Route.CLARIFY:
      return 'CLARIFY'
    case ClassifyResponse_Route.REFUSE:
      return 'REFUSE'
    case ClassifyResponse_Route.DIRECT_ANSWER:
      return 'DIRECT_ANSWER'
    case ClassifyResponse_Route.BACKTEST:
      return 'BACKTEST'
    case ClassifyResponse_Route.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** The report a FOLLOWUP_ON_EXISTING verdict points at. */
export interface ClassifyFollowup {
  /**
   * The parent job, for POST /research/{job_id}/followup or
   * .../followup-research.
   */
  jobId: string
  /**
   * When that report was delivered, ISO-8601 UTC string. Lets a client say
   * which report it is offering.
   */
  deliveredAt: string
}

/** The CLARIFY route's options. */
export interface ClassifyClarify {
  options: ClarifyOption[]
}

/** One clarify hint. Branch on `topic`; show `label`. */
export interface ClarifyOption {
  /** Canonical topic id, e.g. "open_interest". Stable, safe to switch on. */
  topic: string
  /** First-party English label. SWAPPABLE copy, never a key. */
  label: string
}

/** The confirm card: what a tap would run. Single-use. */
export interface Proposal {
  /** Opaque, at most 64 bytes. Sent back as proposal_id on the tap. */
  proposalId: string
  /** First-party one-line summary of what will be researched. Copy, render it. */
  summary: string
  /** Canonical topic ids the message named. */
  topics: string[]
  /** Resolved asset keys, e.g. "BTC". */
  instruments: string[]
  /** The window phrase the message named, normalised; null when none. */
  window?: string | undefined
  /** Venues the message named, in message order. */
  venues: string[]
  /**
   * DIAGNOSTIC code, null on a healthy card: "classifier_unavailable" or
   * "catalog_unavailable" today (open). Never copy, never rendered.
   */
  degraded?: string | undefined
  /**
   * The report length the user chose on this card ("paragraph", "section",
   * "full"), or null when the router sized it. Tells a client where to tap:
   * "full" at POST /research, the other two at POST /research/answer.
   */
  answerScope?: string | undefined
  /** Card expiry, ISO-8601 with a UTC offset, about fifteen minutes out. */
  expiresAt: string
  /**
   * A backtest card's own fields. Set only on the card a "backtest_parse"
   * job's DELIVERED poll serves (ResearchJobStatus.proposal); null on every
   * classify card.
   */
  backtest: BacktestCard | undefined
}

/**
 * What a backtest would run (route BACKTEST), for the user to edit and
 * confirm. Every string is plain text built in code, never model prose and
 * never markdown. A number the user gave is repeated as given and labelled as
 * theirs; every value the service filled in is an editable default. The size
 * is fixed and never taken from the message.
 *
 * THE TAP: POST /research with the proposal arm (proposal_id, thread_id) plus
 * one optional JSON key, "backtest_edits": [{"path": "...", "value": "..."}].
 * Send each path at most once and only paths on the card, each value a string
 * in that field's encoding. Absent or empty runs the card as shown. The 202
 * names a job of kind "backtest", polled like any report: a ResearchReport of
 * markdown blocks. A single run adds two CHART_TYPE_LINE charts with inline
 * series (equity against buy-and-hold, and drawdown); a run that sweeps a
 * field is one results table and no chart. A "scope" key on this tap is a
 * 422: a backtest has no report length. A spent, expired or dismissed card
 * is a 409.
 */
export interface BacktestCard {
  /** The card format's version, starting at 1. */
  specVersion: number
  /** What the run will do, one line each. Copy: render it, never switch on it. */
  lines: string[]
  /**
   * One entry per field the user can change before confirming. A field the
   * run sweeps ("stops of 2%, 3% and 5%") has no entry.
   */
  editable: BacktestEditable[]
  /** Run-wide assumptions the card cannot edit (sizing, fees, slippage). Copy. */
  assumptions: string[]
  /** Caveats on this run. Copy. */
  warnings: string[]
}

/**
 * One editable field on a BacktestCard. `kind`, `origin` and `unit` are OPEN
 * strings (this file's convention): a new value is not a schema event.
 */
export interface BacktestEditable {
  /** Opaque. Echo it back verbatim in backtest_edits; never build or parse one. */
  path: string
  /** First-party label. Copy, never a key. */
  label: string
  /**
   * The current value, a string in the field's encoding and the spec's own
   * units (see `unit`). Null or "" means not set: no stop-loss, or for a date
   * the data's own first or last day ("window.end" is the first day NOT
   * included). Sending "" unsets the field, a 422 on a field the run needs.
   */
  value: string
  /**
   * How to edit it: "enum" (one of `options`), "decimal", "integer" (sent as
   * a decimal string), "date" (YYYY-MM-DD, UTC) or "bool" ("true" or
   * "false"). Show an unknown kind read-only and send no edit for it.
   */
  kind: string
  /** The allowed values when `kind` is "enum"; empty otherwise. */
  options: string[]
  /**
   * Where the value came from: "you" (the user's own words; show it as
   * theirs), "default" (filled in by the service, including a vague phrase
   * read through a fixed table) or "base" (kept from the earlier backtest
   * this one edits). Read an unknown value as "default".
   */
  origin: string
  /**
   * Bounds in the value's encoding, null when there is none. An input hint
   * only: some bounds are exclusive, and the service re-checks every edit.
   */
  min?: string | undefined
  max?: string | undefined
  /**
   * The unit `value`, `min` and `max` are in, or null. "fraction" is a share
   * of one ("0.03" is 3%); "percent" is already in percent; "points", "USD",
   * "bars", "days" and "hour (UTC)" are labels to show beside the value. A
   * "bars" value counts bars of "market.bar", so an edit of "market.bar" must
   * also send every "bars" field that has a value and whose origin is not
   * "default", restated in the new bar. Show an unknown unit as a label.
   */
  unit?: string | undefined
}

/** A run this response already started. */
export interface ClassifyRun {
  /** Pollable at GET /research/{job_id}. */
  jobId: string
}

/**
 * One grounded inline answer (route DIRECT_ANSWER). Two kinds: a REPORT
 * answer (on a thread; cites report blocks or turns, `source_job_id` set) and
 * a CONCEPT answer (a general how-does-it-work question; `sources` empty,
 * `source_job_id` null, no figures). Nothing was started either way.
 */
export interface DirectAnswer {
  /** Markdown, short, with inline [B<n>] / [T<n>] markers naming `sources`. */
  text: string
  /**
   * The blocks and turns the markers name, in first-appearance order. Empty
   * on a concept answer.
   */
  sources: DirectAnswerSource[]
  /** The report the answer came from; null on a concept answer. */
  sourceJobId?: string | undefined
  /** "<model>/<prompt version>" of the answer call. */
  modelVersion: string
}

/**
 * One source of a DirectAnswer. A real oneof: the members PARTITION the
 * fields, as with ReportBlock.
 * JSON wire note: FLATTENED like ReportBlock, but the discriminator key is
 * "kind", not "type": {"kind": "report_block", "block": 2, "section": "..."}
 * or {"kind": "turn", "seq": 7}. "kind" carries the oneof member name. Do not
 * parse the wire through this wrapper; switch on "kind" and parse the flat
 * object with the member type. Skip an unrecognised kind.
 */
export interface DirectAnswerSource {
  reportBlock?: DirectAnswerBlockSource | undefined
  turn?: DirectAnswerTurnSource | undefined
}

/** A block of the report named by DirectAnswer.source_job_id. */
export interface DirectAnswerBlockSource {
  /** 1-BASED position in that report's `blocks` list; the n of [B<n>]. */
  block: number
  /** That block's section label, for display; may be empty. */
  section: string
}

/** A prior turn of the same thread. */
export interface DirectAnswerTurnSource {
  /** The turn's stored seq; the n of [T<n>]. */
  seq: number
}

export interface HomeBriefRequest {
  /** 1 to 9 cards; `id` unique across cards. */
  cards: HomeBriefCard[]
  /** 0 to 4 ideas; `id` unique across ideas. */
  ideas: HomeBriefIdea[]
  book: HomeBriefBook | undefined
  /**
   * True bypasses the service's cache read: the user's "Rewrite" tap.
   * Absent = false.
   */
  refresh: boolean
}

/** One Home datapoint card, as the frontend already renders it. */
export interface HomeBriefCard {
  /**
   * Exactly "<kind>:<asset>", or exactly "fedwatch" for the fedwatch card
   * (the frontend's own id grammar). A mismatch is a 422.
   */
  id: string
  kind: HomeBriefCard_Kind
  /**
   * Base asset, 1 to 16 letters or digits, e.g. "BTC". Null or absent if
   * and only if `kind` is fedwatch. Null and absent mean the same here: a
   * proto serializer omits an unset optional field rather than sending null.
   */
  asset?: string | undefined
  /**
   * The exact line the card already reports, e.g. "Next FOMC (2026-10-28):
   * hold priced at 83%". 1 to 300 characters, not blank, no control
   * characters (no line break or tab) and no Unicode line or paragraph
   * separator (U+2028, U+2029).
   */
  line: string
}

/**
 * The frontend's DatapointKind. A closed set on the service (an unknown
 * kind is a 422).
 */
export enum HomeBriefCard_Kind {
  /** KIND_UNSPECIFIED - Never valid on the wire; a 422. */
  KIND_UNSPECIFIED = 0,
  impliedMove = 1,
  funding = 2,
  marketMove = 3,
  ivPercentile = 4,
  maxPain = 5,
  etfFlows = 6,
  fedwatch = 7,
  skew = 8,
  liquidationLevels = 9,
  UNRECOGNIZED = -1,
}

export function homeBriefCard_KindFromJSON(object: any): HomeBriefCard_Kind {
  switch (object) {
    case 0:
    case 'KIND_UNSPECIFIED':
      return HomeBriefCard_Kind.KIND_UNSPECIFIED
    case 1:
    case 'impliedMove':
      return HomeBriefCard_Kind.impliedMove
    case 2:
    case 'funding':
      return HomeBriefCard_Kind.funding
    case 3:
    case 'marketMove':
      return HomeBriefCard_Kind.marketMove
    case 4:
    case 'ivPercentile':
      return HomeBriefCard_Kind.ivPercentile
    case 5:
    case 'maxPain':
      return HomeBriefCard_Kind.maxPain
    case 6:
    case 'etfFlows':
      return HomeBriefCard_Kind.etfFlows
    case 7:
    case 'fedwatch':
      return HomeBriefCard_Kind.fedwatch
    case 8:
    case 'skew':
      return HomeBriefCard_Kind.skew
    case 9:
    case 'liquidationLevels':
      return HomeBriefCard_Kind.liquidationLevels
    case -1:
    case 'UNRECOGNIZED':
    default:
      return HomeBriefCard_Kind.UNRECOGNIZED
  }
}

export function homeBriefCard_KindToJSON(object: HomeBriefCard_Kind): string {
  switch (object) {
    case HomeBriefCard_Kind.KIND_UNSPECIFIED:
      return 'KIND_UNSPECIFIED'
    case HomeBriefCard_Kind.impliedMove:
      return 'impliedMove'
    case HomeBriefCard_Kind.funding:
      return 'funding'
    case HomeBriefCard_Kind.marketMove:
      return 'marketMove'
    case HomeBriefCard_Kind.ivPercentile:
      return 'ivPercentile'
    case HomeBriefCard_Kind.maxPain:
      return 'maxPain'
    case HomeBriefCard_Kind.etfFlows:
      return 'etfFlows'
    case HomeBriefCard_Kind.fedwatch:
      return 'fedwatch'
    case HomeBriefCard_Kind.skew:
      return 'skew'
    case HomeBriefCard_Kind.liquidationLevels:
      return 'liquidationLevels'
    case HomeBriefCard_Kind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** One reactive idea, as kind plus display facts. */
export interface HomeBriefIdea {
  /**
   * Exactly "<kind>:<symbol>", except hedge, which is exactly
   * "hedge:<asset>" (the frontend's own id grammar). A mismatch is a 422.
   */
  id: string
  kind: HomeBriefIdea_Kind
  /**
   * Venue symbol, 1 to 48 of letters, digits, "_" and "-", e.g.
   * "BTC-PERPETUAL".
   */
  symbol: string
  /** Base asset, 1 to 16 letters or digits. */
  asset: string
  facts: HomeBriefIdeaFacts | undefined
}

/**
 * Reactive kinds only. Not stopLoss, not firstTrade, no opportunity or
 * setup kind: those are a 422 in this version.
 */
export enum HomeBriefIdea_Kind {
  /** KIND_UNSPECIFIED - Never valid on the wire; a 422. */
  KIND_UNSPECIFIED = 0,
  reduce = 1,
  takeProfit = 2,
  expiring = 3,
  hedge = 4,
  funding = 5,
  UNRECOGNIZED = -1,
}

export function homeBriefIdea_KindFromJSON(object: any): HomeBriefIdea_Kind {
  switch (object) {
    case 0:
    case 'KIND_UNSPECIFIED':
      return HomeBriefIdea_Kind.KIND_UNSPECIFIED
    case 1:
    case 'reduce':
      return HomeBriefIdea_Kind.reduce
    case 2:
    case 'takeProfit':
      return HomeBriefIdea_Kind.takeProfit
    case 3:
    case 'expiring':
      return HomeBriefIdea_Kind.expiring
    case 4:
    case 'hedge':
      return HomeBriefIdea_Kind.hedge
    case 5:
    case 'funding':
      return HomeBriefIdea_Kind.funding
    case -1:
    case 'UNRECOGNIZED':
    default:
      return HomeBriefIdea_Kind.UNRECOGNIZED
  }
}

export function homeBriefIdea_KindToJSON(object: HomeBriefIdea_Kind): string {
  switch (object) {
    case HomeBriefIdea_Kind.KIND_UNSPECIFIED:
      return 'KIND_UNSPECIFIED'
    case HomeBriefIdea_Kind.reduce:
      return 'reduce'
    case HomeBriefIdea_Kind.takeProfit:
      return 'takeProfit'
    case HomeBriefIdea_Kind.expiring:
      return 'expiring'
    case HomeBriefIdea_Kind.hedge:
      return 'hedge'
    case HomeBriefIdea_Kind.funding:
      return 'funding'
    case HomeBriefIdea_Kind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * An idea's facts. A CLOSED key set PER KIND; a key outside its kind's set is
 * a 422:
 *   reduce:     leverage (required), liquidation_distance (optional)
 *   takeProfit: pnl (required)
 *   expiring:   hours_to_expiry (required)
 *   funding:    funding_apr (required)
 *   hedge:      book_share (required)
 * A missing required fact is a 422.
 * Every value is a DISPLAY STRING with its unit, matching its key's pattern
 * (a mismatch is a 422), never a bare number. ASCII digits only ([0-9], not
 * a Unicode-aware \d):
 *   leverage                          "12x"   ^[0-9]{1,3}(\.[0-9]{1,2})?x$
 *   liquidation_distance, book_share  "4.1%"  ^[0-9]{1,3}(\.[0-9]{1,2})?%$
 *   pnl, funding_apr                  "-6%"   ^[+-]?[0-9]{1,5}(\.[0-9]{1,2})?%$
 *   hours_to_expiry                   "18h"   ^[0-9]{1,3}h$
 */
export interface HomeBriefIdeaFacts {
  leverage?: string | undefined
  liquidationDistance?: string | undefined
  pnl?: string | undefined
  hoursToExpiry?: string | undefined
  fundingApr?: string | undefined
  bookShare?: string | undefined
}

/** The user's book, summarised. */
export interface HomeBriefBook {
  /**
   * Strict integer, 0 to 10000. REQUIRED, including when it is 0: the key
   * must be present. Optional in proto only so that a serializer that skips
   * zero values still sends an explicitly set 0 (an absent key is a 422).
   */
  openOrderCount?: number | undefined
  /** 0 to 20 positions. */
  positions: HomeBriefPosition[]
}

/**
 * One open position. Optional fields are display strings with the same
 * patterns as HomeBriefIdeaFacts.
 */
export interface HomeBriefPosition {
  /** Same pattern as HomeBriefIdea.symbol. REQUIRED. */
  symbol: string
  /**
   * "long" or "short", the service's closed literal. REQUIRED. A plain
   * string: both words are reserved in common codegen targets, so an enum
   * member spelled as the wire value is not portable.
   */
  side: string
  leverage?: string | undefined
  liquidationDistance?: string | undefined
  pnl?: string | undefined
  bookShare?: string | undefined
}

/**
 * The 200 body. 200 exactly when at least one non-blank guarded item survives
 * (one brief section, one card note or one idea reasoning); otherwise 503.
 * Plain prose throughout, no markdown. Like CLASSIFY, a dropped brief section
 * arrives as JSON null rather than absent; treat null and absent alike.
 */
export interface HomeBriefResponse {
  /** Always an object. */
  brief: HomeBriefSections | undefined
  /** Only ids from the request, at most one note per card id. */
  cardNotes: HomeBriefCardNote[]
  /** Only ids from the request, at most one per idea id. */
  ideaReasoning: HomeBriefIdeaReasoning[]
  /**
   * Exactly one entry per requested card id and idea id with no surviving
   * item.
   */
  omitted: HomeBriefOmission[]
  /** One entry per null brief section. */
  omittedSections: HomeBriefSectionOmission[]
  /**
   * When the brief was generated, ISO-8601 UTC string, e.g.
   * "2026-10-15T07:02:11Z". On a cache hit, the original generation time.
   */
  generatedAt: string
  /** True when served from the service's cache rather than generated now. */
  cached: boolean
  /** "<model>/<prompt version>", e.g. "gemini-3.8-flash/home-brief-v1". */
  modelVersion: string
  requestId: string
}

/**
 * The three-part brief. Each section is an object, or null when it was
 * dropped (and then listed in HomeBriefResponse.omitted_sections).
 */
export interface HomeBriefSections {
  /** What changed. At most 300 characters. */
  changed: HomeBriefText | undefined
  /** What it means. At most 300 characters. */
  meaning: HomeBriefText | undefined
  /** What to watch. At most 300 characters. */
  watch: HomeBriefText | undefined
}

/** One brief section's text and the sources of its figures. */
export interface HomeBriefText {
  text: string
  quotes: HomeBriefQuote[]
}

/**
 * For one figure in a text: the exact source string that licensed it and
 * where it came from. Filled by the service from its own match against the
 * request; it re-shapes what was matched and computes nothing. The frontend
 * hides a note whose quote no longer appears in its live source.
 */
export interface HomeBriefQuote {
  /**
   * Where the figure came from, one of:
   *   "card:<card id>"
   *   "idea:<idea id>.<fact key>"
   *   "book.positions[<index>].<field>"  (index 0-based, request order)
   *   "book.open_order_count"
   */
  src: string
  /** The exact source string, e.g. "±3.1%" or "12x". */
  text: string
}

/** One card's note. At most 220 characters. */
export interface HomeBriefCardNote {
  /** A card id from the request. */
  id: string
  note: string
  quotes: HomeBriefQuote[]
}

/** One idea's reasoning. At most 320 characters. */
export interface HomeBriefIdeaReasoning {
  /** An idea id from the request. */
  id: string
  text: string
  quotes: HomeBriefQuote[]
}

/** A requested card or idea with no surviving item. */
export interface HomeBriefOmission {
  /** The card id or idea id from the request. */
  id: string
  /**
   * The first reason that dropped it. A CODE, never text (this file's
   * diagnostic rule): "no_note", "empty", "unsourced_number",
   * "spelled_figure", "price_like", "level_language", "sign_conflict",
   * "too_long", "format", "stale". Open: render an unrecognised code as a
   * generic omission.
   */
  reason: string
}

/** A brief section that is null. */
export interface HomeBriefSectionOmission {
  /** "changed", "meaning" or "watch". */
  section: string
  /** Same code vocabulary as HomeBriefOmission.reason. */
  reason: string
}

function createBaseResearchReport(): ResearchReport {
  return { meta: undefined, blocks: [], citations: [] }
}

export const ResearchReport: MessageFns<ResearchReport> = {
  encode(message: ResearchReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.meta !== undefined) {
      ReportMeta.encode(message.meta, writer.uint32(10).fork()).join()
    }
    for (const v of message.blocks) {
      ReportBlock.encode(v!, writer.uint32(18).fork()).join()
    }
    for (const v of message.citations) {
      Citation.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResearchReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResearchReport()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.meta = ReportMeta.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.blocks.push(ReportBlock.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.citations.push(Citation.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResearchReport {
    return {
      meta: isSet(object.meta) ? ReportMeta.fromJSON(object.meta) : undefined,
      blocks: globalThis.Array.isArray(object?.blocks)
        ? object.blocks.map((e: any) => ReportBlock.fromJSON(e))
        : [],
      citations: globalThis.Array.isArray(object?.citations)
        ? object.citations.map((e: any) => Citation.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ResearchReport): unknown {
    const obj: any = {}
    if (message.meta !== undefined) {
      obj.meta = ReportMeta.toJSON(message.meta)
    }
    if (message.blocks?.length) {
      obj.blocks = message.blocks.map((e) => ReportBlock.toJSON(e))
    }
    if (message.citations?.length) {
      obj.citations = message.citations.map((e) => Citation.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResearchReport>, I>>(base?: I): ResearchReport {
    return ResearchReport.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResearchReport>, I>>(object: I): ResearchReport {
    const message = createBaseResearchReport()
    message.meta =
      object.meta !== undefined && object.meta !== null
        ? ReportMeta.fromPartial(object.meta)
        : undefined
    message.blocks = object.blocks?.map((e) => ReportBlock.fromPartial(e)) || []
    message.citations = object.citations?.map((e) => Citation.fromPartial(e)) || []
    return message
  },
}

function createBaseReportMeta(): ReportMeta {
  return {
    jobId: '',
    useCase: '',
    disclaimers: [],
    durationSeconds: undefined,
    parentJobId: undefined,
    scope: undefined,
  }
}

export const ReportMeta: MessageFns<ReportMeta> = {
  encode(message: ReportMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== '') {
      writer.uint32(10).string(message.jobId)
    }
    if (message.useCase !== '') {
      writer.uint32(18).string(message.useCase)
    }
    for (const v of message.disclaimers) {
      writer.uint32(26).string(v!)
    }
    if (message.durationSeconds !== undefined) {
      writer.uint32(33).double(message.durationSeconds)
    }
    if (message.parentJobId !== undefined) {
      writer.uint32(42).string(message.parentJobId)
    }
    if (message.scope !== undefined) {
      writer.uint32(50).string(message.scope)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReportMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseReportMeta()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.jobId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.useCase = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.disclaimers.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 33) {
            break
          }

          message.durationSeconds = reader.double()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.parentJobId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.scope = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ReportMeta {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
          ? globalThis.String(object.job_id)
          : '',
      useCase: isSet(object.useCase)
        ? globalThis.String(object.useCase)
        : isSet(object.use_case)
          ? globalThis.String(object.use_case)
          : '',
      disclaimers: globalThis.Array.isArray(object?.disclaimers)
        ? object.disclaimers.map((e: any) => globalThis.String(e))
        : [],
      durationSeconds: isSet(object.durationSeconds)
        ? globalThis.Number(object.durationSeconds)
        : isSet(object.duration_seconds)
          ? globalThis.Number(object.duration_seconds)
          : undefined,
      parentJobId: isSet(object.parentJobId)
        ? globalThis.String(object.parentJobId)
        : isSet(object.parent_job_id)
          ? globalThis.String(object.parent_job_id)
          : undefined,
      scope: isSet(object.scope) ? globalThis.String(object.scope) : undefined,
    }
  },

  toJSON(message: ReportMeta): unknown {
    const obj: any = {}
    if (message.jobId !== '') {
      obj.jobId = message.jobId
    }
    if (message.useCase !== '') {
      obj.useCase = message.useCase
    }
    if (message.disclaimers?.length) {
      obj.disclaimers = message.disclaimers
    }
    if (message.durationSeconds !== undefined) {
      obj.durationSeconds = message.durationSeconds
    }
    if (message.parentJobId !== undefined) {
      obj.parentJobId = message.parentJobId
    }
    if (message.scope !== undefined) {
      obj.scope = message.scope
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ReportMeta>, I>>(base?: I): ReportMeta {
    return ReportMeta.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ReportMeta>, I>>(object: I): ReportMeta {
    const message = createBaseReportMeta()
    message.jobId = object.jobId ?? ''
    message.useCase = object.useCase ?? ''
    message.disclaimers = object.disclaimers?.map((e) => e) || []
    message.durationSeconds = object.durationSeconds ?? undefined
    message.parentJobId = object.parentJobId ?? undefined
    message.scope = object.scope ?? undefined
    return message
  },
}

function createBaseCitation(): Citation {
  return {
    marker: '',
    tool: '',
    sourceTable: '',
    timeRange: undefined,
    rowCount: 0,
    label: undefined,
  }
}

export const Citation: MessageFns<Citation> = {
  encode(message: Citation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.marker !== '') {
      writer.uint32(10).string(message.marker)
    }
    if (message.tool !== '') {
      writer.uint32(18).string(message.tool)
    }
    if (message.sourceTable !== '') {
      writer.uint32(26).string(message.sourceTable)
    }
    if (message.timeRange !== undefined) {
      TimeRange.encode(message.timeRange, writer.uint32(34).fork()).join()
    }
    if (message.rowCount !== 0) {
      writer.uint32(40).int32(message.rowCount)
    }
    if (message.label !== undefined) {
      writer.uint32(50).string(message.label)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Citation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCitation()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.marker = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.tool = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sourceTable = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.timeRange = TimeRange.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.rowCount = reader.int32()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.label = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Citation {
    return {
      marker: isSet(object.marker) ? globalThis.String(object.marker) : '',
      tool: isSet(object.tool) ? globalThis.String(object.tool) : '',
      sourceTable: isSet(object.sourceTable)
        ? globalThis.String(object.sourceTable)
        : isSet(object.source_table)
          ? globalThis.String(object.source_table)
          : '',
      timeRange: isSet(object.timeRange)
        ? TimeRange.fromJSON(object.timeRange)
        : isSet(object.time_range)
          ? TimeRange.fromJSON(object.time_range)
          : undefined,
      rowCount: isSet(object.rowCount)
        ? globalThis.Number(object.rowCount)
        : isSet(object.row_count)
          ? globalThis.Number(object.row_count)
          : 0,
      label: isSet(object.label) ? globalThis.String(object.label) : undefined,
    }
  },

  toJSON(message: Citation): unknown {
    const obj: any = {}
    if (message.marker !== '') {
      obj.marker = message.marker
    }
    if (message.tool !== '') {
      obj.tool = message.tool
    }
    if (message.sourceTable !== '') {
      obj.sourceTable = message.sourceTable
    }
    if (message.timeRange !== undefined) {
      obj.timeRange = TimeRange.toJSON(message.timeRange)
    }
    if (message.rowCount !== 0) {
      obj.rowCount = Math.round(message.rowCount)
    }
    if (message.label !== undefined) {
      obj.label = message.label
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Citation>, I>>(base?: I): Citation {
    return Citation.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Citation>, I>>(object: I): Citation {
    const message = createBaseCitation()
    message.marker = object.marker ?? ''
    message.tool = object.tool ?? ''
    message.sourceTable = object.sourceTable ?? ''
    message.timeRange =
      object.timeRange !== undefined && object.timeRange !== null
        ? TimeRange.fromPartial(object.timeRange)
        : undefined
    message.rowCount = object.rowCount ?? 0
    message.label = object.label ?? undefined
    return message
  },
}

function createBaseTimeRange(): TimeRange {
  return { start: '', end: '' }
}

export const TimeRange: MessageFns<TimeRange> = {
  encode(message: TimeRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== '') {
      writer.uint32(10).string(message.start)
    }
    if (message.end !== '') {
      writer.uint32(18).string(message.end)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTimeRange()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.start = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.end = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TimeRange {
    return {
      start: isSet(object.start) ? globalThis.String(object.start) : '',
      end: isSet(object.end) ? globalThis.String(object.end) : '',
    }
  },

  toJSON(message: TimeRange): unknown {
    const obj: any = {}
    if (message.start !== '') {
      obj.start = message.start
    }
    if (message.end !== '') {
      obj.end = message.end
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TimeRange>, I>>(base?: I): TimeRange {
    return TimeRange.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TimeRange>, I>>(object: I): TimeRange {
    const message = createBaseTimeRange()
    message.start = object.start ?? ''
    message.end = object.end ?? ''
    return message
  },
}

function createBaseReportBlock(): ReportBlock {
  return { markdown: undefined, chart: undefined }
}

export const ReportBlock: MessageFns<ReportBlock> = {
  encode(message: ReportBlock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.markdown !== undefined) {
      MarkdownBlock.encode(message.markdown, writer.uint32(10).fork()).join()
    }
    if (message.chart !== undefined) {
      ChartBlock.encode(message.chart, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReportBlock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseReportBlock()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.markdown = MarkdownBlock.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.chart = ChartBlock.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ReportBlock {
    return {
      markdown: isSet(object.markdown) ? MarkdownBlock.fromJSON(object.markdown) : undefined,
      chart: isSet(object.chart) ? ChartBlock.fromJSON(object.chart) : undefined,
    }
  },

  toJSON(message: ReportBlock): unknown {
    const obj: any = {}
    if (message.markdown !== undefined) {
      obj.markdown = MarkdownBlock.toJSON(message.markdown)
    }
    if (message.chart !== undefined) {
      obj.chart = ChartBlock.toJSON(message.chart)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ReportBlock>, I>>(base?: I): ReportBlock {
    return ReportBlock.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ReportBlock>, I>>(object: I): ReportBlock {
    const message = createBaseReportBlock()
    message.markdown =
      object.markdown !== undefined && object.markdown !== null
        ? MarkdownBlock.fromPartial(object.markdown)
        : undefined
    message.chart =
      object.chart !== undefined && object.chart !== null
        ? ChartBlock.fromPartial(object.chart)
        : undefined
    return message
  },
}

function createBaseMarkdownBlock(): MarkdownBlock {
  return { section: '', content: '', sources: [] }
}

export const MarkdownBlock: MessageFns<MarkdownBlock> = {
  encode(message: MarkdownBlock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.section !== '') {
      writer.uint32(10).string(message.section)
    }
    if (message.content !== '') {
      writer.uint32(18).string(message.content)
    }
    for (const v of message.sources) {
      writer.uint32(26).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarkdownBlock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMarkdownBlock()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.section = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.content = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sources.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MarkdownBlock {
    return {
      section: isSet(object.section) ? globalThis.String(object.section) : '',
      content: isSet(object.content) ? globalThis.String(object.content) : '',
      sources: globalThis.Array.isArray(object?.sources)
        ? object.sources.map((e: any) => globalThis.String(e))
        : [],
    }
  },

  toJSON(message: MarkdownBlock): unknown {
    const obj: any = {}
    if (message.section !== '') {
      obj.section = message.section
    }
    if (message.content !== '') {
      obj.content = message.content
    }
    if (message.sources?.length) {
      obj.sources = message.sources
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MarkdownBlock>, I>>(base?: I): MarkdownBlock {
    return MarkdownBlock.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MarkdownBlock>, I>>(object: I): MarkdownBlock {
    const message = createBaseMarkdownBlock()
    message.section = object.section ?? ''
    message.content = object.content ?? ''
    message.sources = object.sources?.map((e) => e) || []
    return message
  },
}

function createBaseChartBlock(): ChartBlock {
  return {
    schemaVersion: 0,
    section: '',
    caption: '',
    chartType: 0,
    reference: undefined,
    series: [],
    integrity: undefined,
    isPreview: false,
    truncated: false,
    aggregates: {},
    sources: [],
  }
}

export const ChartBlock: MessageFns<ChartBlock> = {
  encode(message: ChartBlock, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.schemaVersion !== 0) {
      writer.uint32(8).int32(message.schemaVersion)
    }
    if (message.section !== '') {
      writer.uint32(18).string(message.section)
    }
    if (message.caption !== '') {
      writer.uint32(26).string(message.caption)
    }
    if (message.chartType !== 0) {
      writer.uint32(32).int32(message.chartType)
    }
    if (message.reference !== undefined) {
      ChartReference.encode(message.reference, writer.uint32(42).fork()).join()
    }
    for (const v of message.series) {
      ChartSeries.encode(v!, writer.uint32(50).fork()).join()
    }
    if (message.integrity !== undefined) {
      ChartIntegrity.encode(message.integrity, writer.uint32(58).fork()).join()
    }
    if (message.isPreview !== false) {
      writer.uint32(64).bool(message.isPreview)
    }
    if (message.truncated !== false) {
      writer.uint32(72).bool(message.truncated)
    }
    globalThis.Object.entries(message.aggregates).forEach(([key, value]: [string, string]) => {
      ChartBlock_AggregatesEntry.encode({ key: key as any, value }, writer.uint32(82).fork()).join()
    })
    for (const v of message.sources) {
      writer.uint32(90).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartBlock {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartBlock()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.schemaVersion = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.section = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.caption = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.chartType = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.reference = ChartReference.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.series.push(ChartSeries.decode(reader, reader.uint32()))
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.integrity = ChartIntegrity.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.isPreview = reader.bool()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.truncated = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          const entry10 = ChartBlock_AggregatesEntry.decode(reader, reader.uint32())
          if (entry10.value !== undefined) {
            message.aggregates[entry10.key] = entry10.value
          }
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.sources.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartBlock {
    return {
      schemaVersion: isSet(object.schemaVersion)
        ? globalThis.Number(object.schemaVersion)
        : isSet(object.schema_version)
          ? globalThis.Number(object.schema_version)
          : 0,
      section: isSet(object.section) ? globalThis.String(object.section) : '',
      caption: isSet(object.caption) ? globalThis.String(object.caption) : '',
      chartType: isSet(object.chartType)
        ? chartTypeFromJSON(object.chartType)
        : isSet(object.chart_type)
          ? chartTypeFromJSON(object.chart_type)
          : 0,
      reference: isSet(object.reference) ? ChartReference.fromJSON(object.reference) : undefined,
      series: globalThis.Array.isArray(object?.series)
        ? object.series.map((e: any) => ChartSeries.fromJSON(e))
        : [],
      integrity: isSet(object.integrity) ? ChartIntegrity.fromJSON(object.integrity) : undefined,
      isPreview: isSet(object.isPreview)
        ? globalThis.Boolean(object.isPreview)
        : isSet(object.is_preview)
          ? globalThis.Boolean(object.is_preview)
          : false,
      truncated: isSet(object.truncated) ? globalThis.Boolean(object.truncated) : false,
      aggregates: isObject(object.aggregates)
        ? (globalThis.Object.entries(object.aggregates) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : {},
      sources: globalThis.Array.isArray(object?.sources)
        ? object.sources.map((e: any) => globalThis.String(e))
        : [],
    }
  },

  toJSON(message: ChartBlock): unknown {
    const obj: any = {}
    if (message.schemaVersion !== 0) {
      obj.schemaVersion = Math.round(message.schemaVersion)
    }
    if (message.section !== '') {
      obj.section = message.section
    }
    if (message.caption !== '') {
      obj.caption = message.caption
    }
    if (message.chartType !== 0) {
      obj.chartType = chartTypeToJSON(message.chartType)
    }
    if (message.reference !== undefined) {
      obj.reference = ChartReference.toJSON(message.reference)
    }
    if (message.series?.length) {
      obj.series = message.series.map((e) => ChartSeries.toJSON(e))
    }
    if (message.integrity !== undefined) {
      obj.integrity = ChartIntegrity.toJSON(message.integrity)
    }
    if (message.isPreview !== false) {
      obj.isPreview = message.isPreview
    }
    if (message.truncated !== false) {
      obj.truncated = message.truncated
    }
    if (message.aggregates) {
      const entries = globalThis.Object.entries(message.aggregates) as [string, string][]
      if (entries.length > 0) {
        obj.aggregates = {}
        entries.forEach(([k, v]) => {
          obj.aggregates[k] = v
        })
      }
    }
    if (message.sources?.length) {
      obj.sources = message.sources
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartBlock>, I>>(base?: I): ChartBlock {
    return ChartBlock.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartBlock>, I>>(object: I): ChartBlock {
    const message = createBaseChartBlock()
    message.schemaVersion = object.schemaVersion ?? 0
    message.section = object.section ?? ''
    message.caption = object.caption ?? ''
    message.chartType = object.chartType ?? 0
    message.reference =
      object.reference !== undefined && object.reference !== null
        ? ChartReference.fromPartial(object.reference)
        : undefined
    message.series = object.series?.map((e) => ChartSeries.fromPartial(e)) || []
    message.integrity =
      object.integrity !== undefined && object.integrity !== null
        ? ChartIntegrity.fromPartial(object.integrity)
        : undefined
    message.isPreview = object.isPreview ?? false
    message.truncated = object.truncated ?? false
    message.aggregates = (
      globalThis.Object.entries(object.aggregates ?? {}) as [string, string][]
    ).reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    message.sources = object.sources?.map((e) => e) || []
    return message
  },
}

function createBaseChartBlock_AggregatesEntry(): ChartBlock_AggregatesEntry {
  return { key: '', value: '' }
}

export const ChartBlock_AggregatesEntry: MessageFns<ChartBlock_AggregatesEntry> = {
  encode(
    message: ChartBlock_AggregatesEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartBlock_AggregatesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartBlock_AggregatesEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartBlock_AggregatesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: ChartBlock_AggregatesEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartBlock_AggregatesEntry>, I>>(
    base?: I
  ): ChartBlock_AggregatesEntry {
    return ChartBlock_AggregatesEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartBlock_AggregatesEntry>, I>>(
    object: I
  ): ChartBlock_AggregatesEntry {
    const message = createBaseChartBlock_AggregatesEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseChartReference(): ChartReference {
  return {
    symbol: '',
    exchange: 0,
    intervalSeconds: 0,
    fromTs: '0',
    toTs: '0',
    live: false,
    feed: '',
  }
}

export const ChartReference: MessageFns<ChartReference> = {
  encode(message: ChartReference, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.intervalSeconds !== 0) {
      writer.uint32(24).int32(message.intervalSeconds)
    }
    if (message.fromTs !== '0') {
      writer.uint32(32).int64(message.fromTs)
    }
    if (message.toTs !== '0') {
      writer.uint32(40).int64(message.toTs)
    }
    if (message.live !== false) {
      writer.uint32(48).bool(message.live)
    }
    if (message.feed !== '') {
      writer.uint32(58).string(message.feed)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartReference {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartReference()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.intervalSeconds = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.fromTs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.toTs = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.live = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.feed = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartReference {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      intervalSeconds: isSet(object.intervalSeconds)
        ? chartTimeframeFromJSON(object.intervalSeconds)
        : isSet(object.interval_seconds)
          ? chartTimeframeFromJSON(object.interval_seconds)
          : 0,
      fromTs: isSet(object.fromTs)
        ? globalThis.String(object.fromTs)
        : isSet(object.from_ts)
          ? globalThis.String(object.from_ts)
          : '0',
      toTs: isSet(object.toTs)
        ? globalThis.String(object.toTs)
        : isSet(object.to_ts)
          ? globalThis.String(object.to_ts)
          : '0',
      live: isSet(object.live) ? globalThis.Boolean(object.live) : false,
      feed: isSet(object.feed) ? globalThis.String(object.feed) : '',
    }
  },

  toJSON(message: ChartReference): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.intervalSeconds !== 0) {
      obj.intervalSeconds = chartTimeframeToJSON(message.intervalSeconds)
    }
    if (message.fromTs !== '0') {
      obj.fromTs = message.fromTs
    }
    if (message.toTs !== '0') {
      obj.toTs = message.toTs
    }
    if (message.live !== false) {
      obj.live = message.live
    }
    if (message.feed !== '') {
      obj.feed = message.feed
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartReference>, I>>(base?: I): ChartReference {
    return ChartReference.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartReference>, I>>(object: I): ChartReference {
    const message = createBaseChartReference()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.intervalSeconds = object.intervalSeconds ?? 0
    message.fromTs = object.fromTs ?? '0'
    message.toTs = object.toTs ?? '0'
    message.live = object.live ?? false
    message.feed = object.feed ?? ''
    return message
  },
}

function createBaseChartSeries(): ChartSeries {
  return { label: '', points: [], axis: 0 }
}

export const ChartSeries: MessageFns<ChartSeries> = {
  encode(message: ChartSeries, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    for (const v of message.points) {
      ChartPoint.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.axis !== 0) {
      writer.uint32(24).int32(message.axis)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartSeries {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartSeries()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.points.push(ChartPoint.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.axis = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartSeries {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      points: globalThis.Array.isArray(object?.points)
        ? object.points.map((e: any) => ChartPoint.fromJSON(e))
        : [],
      axis: isSet(object.axis) ? seriesAxisFromJSON(object.axis) : 0,
    }
  },

  toJSON(message: ChartSeries): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.points?.length) {
      obj.points = message.points.map((e) => ChartPoint.toJSON(e))
    }
    if (message.axis !== 0) {
      obj.axis = seriesAxisToJSON(message.axis)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartSeries>, I>>(base?: I): ChartSeries {
    return ChartSeries.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartSeries>, I>>(object: I): ChartSeries {
    const message = createBaseChartSeries()
    message.label = object.label ?? ''
    message.points = object.points?.map((e) => ChartPoint.fromPartial(e)) || []
    message.axis = object.axis ?? 0
    return message
  },
}

function createBaseChartPoint(): ChartPoint {
  return { tMs: '', v: undefined, o: undefined, h: undefined, l: undefined, c: undefined }
}

export const ChartPoint: MessageFns<ChartPoint> = {
  encode(message: ChartPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tMs !== '') {
      writer.uint32(10).string(message.tMs)
    }
    if (message.v !== undefined) {
      writer.uint32(18).string(message.v)
    }
    if (message.o !== undefined) {
      writer.uint32(26).string(message.o)
    }
    if (message.h !== undefined) {
      writer.uint32(34).string(message.h)
    }
    if (message.l !== undefined) {
      writer.uint32(42).string(message.l)
    }
    if (message.c !== undefined) {
      writer.uint32(50).string(message.c)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartPoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tMs = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.v = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.o = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.h = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.l = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.c = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartPoint {
    return {
      tMs: isSet(object.tMs)
        ? globalThis.String(object.tMs)
        : isSet(object.t_ms)
          ? globalThis.String(object.t_ms)
          : '',
      v: isSet(object.v) ? globalThis.String(object.v) : undefined,
      o: isSet(object.o) ? globalThis.String(object.o) : undefined,
      h: isSet(object.h) ? globalThis.String(object.h) : undefined,
      l: isSet(object.l) ? globalThis.String(object.l) : undefined,
      c: isSet(object.c) ? globalThis.String(object.c) : undefined,
    }
  },

  toJSON(message: ChartPoint): unknown {
    const obj: any = {}
    if (message.tMs !== '') {
      obj.tMs = message.tMs
    }
    if (message.v !== undefined) {
      obj.v = message.v
    }
    if (message.o !== undefined) {
      obj.o = message.o
    }
    if (message.h !== undefined) {
      obj.h = message.h
    }
    if (message.l !== undefined) {
      obj.l = message.l
    }
    if (message.c !== undefined) {
      obj.c = message.c
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartPoint>, I>>(base?: I): ChartPoint {
    return ChartPoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartPoint>, I>>(object: I): ChartPoint {
    const message = createBaseChartPoint()
    message.tMs = object.tMs ?? ''
    message.v = object.v ?? undefined
    message.o = object.o ?? undefined
    message.h = object.h ?? undefined
    message.l = object.l ?? undefined
    message.c = object.c ?? undefined
    return message
  },
}

function createBaseChartIntegrity(): ChartIntegrity {
  return { rows: 0, first: undefined, last: undefined, checksum: undefined }
}

export const ChartIntegrity: MessageFns<ChartIntegrity> = {
  encode(message: ChartIntegrity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rows !== 0) {
      writer.uint32(8).int32(message.rows)
    }
    if (message.first !== undefined) {
      writer.uint32(18).string(message.first)
    }
    if (message.last !== undefined) {
      writer.uint32(26).string(message.last)
    }
    if (message.checksum !== undefined) {
      writer.uint32(34).string(message.checksum)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChartIntegrity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChartIntegrity()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.rows = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.first = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.last = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.checksum = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChartIntegrity {
    return {
      rows: isSet(object.rows) ? globalThis.Number(object.rows) : 0,
      first: isSet(object.first) ? globalThis.String(object.first) : undefined,
      last: isSet(object.last) ? globalThis.String(object.last) : undefined,
      checksum: isSet(object.checksum) ? globalThis.String(object.checksum) : undefined,
    }
  },

  toJSON(message: ChartIntegrity): unknown {
    const obj: any = {}
    if (message.rows !== 0) {
      obj.rows = Math.round(message.rows)
    }
    if (message.first !== undefined) {
      obj.first = message.first
    }
    if (message.last !== undefined) {
      obj.last = message.last
    }
    if (message.checksum !== undefined) {
      obj.checksum = message.checksum
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChartIntegrity>, I>>(base?: I): ChartIntegrity {
    return ChartIntegrity.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChartIntegrity>, I>>(object: I): ChartIntegrity {
    const message = createBaseChartIntegrity()
    message.rows = object.rows ?? 0
    message.first = object.first ?? undefined
    message.last = object.last ?? undefined
    message.checksum = object.checksum ?? undefined
    return message
  },
}

function createBaseResearchJobStatus(): ResearchJobStatus {
  return {
    jobId: '',
    phase: 0,
    parentJobId: undefined,
    events: [],
    report: undefined,
    kind: undefined,
    scope: undefined,
    errorCode: undefined,
    recovery: undefined,
    retryable: undefined,
    proposal: undefined,
  }
}

export const ResearchJobStatus: MessageFns<ResearchJobStatus> = {
  encode(message: ResearchJobStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== '') {
      writer.uint32(10).string(message.jobId)
    }
    if (message.phase !== 0) {
      writer.uint32(16).int32(message.phase)
    }
    if (message.parentJobId !== undefined) {
      writer.uint32(26).string(message.parentJobId)
    }
    for (const v of message.events) {
      ResearchJobEvent.encode(v!, writer.uint32(34).fork()).join()
    }
    if (message.report !== undefined) {
      ResearchReport.encode(message.report, writer.uint32(42).fork()).join()
    }
    if (message.kind !== undefined) {
      writer.uint32(50).string(message.kind)
    }
    if (message.scope !== undefined) {
      writer.uint32(58).string(message.scope)
    }
    if (message.errorCode !== undefined) {
      writer.uint32(66).string(message.errorCode)
    }
    if (message.recovery !== undefined) {
      RecoveryRequest.encode(message.recovery, writer.uint32(74).fork()).join()
    }
    if (message.retryable !== undefined) {
      writer.uint32(80).bool(message.retryable)
    }
    if (message.proposal !== undefined) {
      Proposal.encode(message.proposal, writer.uint32(90).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResearchJobStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResearchJobStatus()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.jobId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.phase = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.parentJobId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.events.push(ResearchJobEvent.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.report = ResearchReport.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.kind = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.scope = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.errorCode = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.recovery = RecoveryRequest.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.retryable = reader.bool()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.proposal = Proposal.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResearchJobStatus {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
          ? globalThis.String(object.job_id)
          : '',
      phase: isSet(object.phase) ? researchJobStatus_PhaseFromJSON(object.phase) : 0,
      parentJobId: isSet(object.parentJobId)
        ? globalThis.String(object.parentJobId)
        : isSet(object.parent_job_id)
          ? globalThis.String(object.parent_job_id)
          : undefined,
      events: globalThis.Array.isArray(object?.events)
        ? object.events.map((e: any) => ResearchJobEvent.fromJSON(e))
        : [],
      report: isSet(object.report) ? ResearchReport.fromJSON(object.report) : undefined,
      kind: isSet(object.kind) ? globalThis.String(object.kind) : undefined,
      scope: isSet(object.scope) ? globalThis.String(object.scope) : undefined,
      errorCode: isSet(object.errorCode)
        ? globalThis.String(object.errorCode)
        : isSet(object.error_code)
          ? globalThis.String(object.error_code)
          : undefined,
      recovery: isSet(object.recovery) ? RecoveryRequest.fromJSON(object.recovery) : undefined,
      retryable: isSet(object.retryable) ? globalThis.Boolean(object.retryable) : undefined,
      proposal: isSet(object.proposal) ? Proposal.fromJSON(object.proposal) : undefined,
    }
  },

  toJSON(message: ResearchJobStatus): unknown {
    const obj: any = {}
    if (message.jobId !== '') {
      obj.jobId = message.jobId
    }
    if (message.phase !== 0) {
      obj.phase = researchJobStatus_PhaseToJSON(message.phase)
    }
    if (message.parentJobId !== undefined) {
      obj.parentJobId = message.parentJobId
    }
    if (message.events?.length) {
      obj.events = message.events.map((e) => ResearchJobEvent.toJSON(e))
    }
    if (message.report !== undefined) {
      obj.report = ResearchReport.toJSON(message.report)
    }
    if (message.kind !== undefined) {
      obj.kind = message.kind
    }
    if (message.scope !== undefined) {
      obj.scope = message.scope
    }
    if (message.errorCode !== undefined) {
      obj.errorCode = message.errorCode
    }
    if (message.recovery !== undefined) {
      obj.recovery = RecoveryRequest.toJSON(message.recovery)
    }
    if (message.retryable !== undefined) {
      obj.retryable = message.retryable
    }
    if (message.proposal !== undefined) {
      obj.proposal = Proposal.toJSON(message.proposal)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResearchJobStatus>, I>>(base?: I): ResearchJobStatus {
    return ResearchJobStatus.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResearchJobStatus>, I>>(object: I): ResearchJobStatus {
    const message = createBaseResearchJobStatus()
    message.jobId = object.jobId ?? ''
    message.phase = object.phase ?? 0
    message.parentJobId = object.parentJobId ?? undefined
    message.events = object.events?.map((e) => ResearchJobEvent.fromPartial(e)) || []
    message.report =
      object.report !== undefined && object.report !== null
        ? ResearchReport.fromPartial(object.report)
        : undefined
    message.kind = object.kind ?? undefined
    message.scope = object.scope ?? undefined
    message.errorCode = object.errorCode ?? undefined
    message.recovery =
      object.recovery !== undefined && object.recovery !== null
        ? RecoveryRequest.fromPartial(object.recovery)
        : undefined
    message.retryable = object.retryable ?? undefined
    message.proposal =
      object.proposal !== undefined && object.proposal !== null
        ? Proposal.fromPartial(object.proposal)
        : undefined
    return message
  },
}

function createBaseRecoveryRequest(): RecoveryRequest {
  return { question: '', parentJobId: undefined, scope: '', threadId: undefined }
}

export const RecoveryRequest: MessageFns<RecoveryRequest> = {
  encode(message: RecoveryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.question !== '') {
      writer.uint32(10).string(message.question)
    }
    if (message.parentJobId !== undefined) {
      writer.uint32(18).string(message.parentJobId)
    }
    if (message.scope !== '') {
      writer.uint32(26).string(message.scope)
    }
    if (message.threadId !== undefined) {
      writer.uint32(34).string(message.threadId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecoveryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRecoveryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.question = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.parentJobId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.scope = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.threadId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RecoveryRequest {
    return {
      question: isSet(object.question) ? globalThis.String(object.question) : '',
      parentJobId: isSet(object.parentJobId)
        ? globalThis.String(object.parentJobId)
        : isSet(object.parent_job_id)
          ? globalThis.String(object.parent_job_id)
          : undefined,
      scope: isSet(object.scope) ? globalThis.String(object.scope) : '',
      threadId: isSet(object.threadId)
        ? globalThis.String(object.threadId)
        : isSet(object.thread_id)
          ? globalThis.String(object.thread_id)
          : undefined,
    }
  },

  toJSON(message: RecoveryRequest): unknown {
    const obj: any = {}
    if (message.question !== '') {
      obj.question = message.question
    }
    if (message.parentJobId !== undefined) {
      obj.parentJobId = message.parentJobId
    }
    if (message.scope !== '') {
      obj.scope = message.scope
    }
    if (message.threadId !== undefined) {
      obj.threadId = message.threadId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RecoveryRequest>, I>>(base?: I): RecoveryRequest {
    return RecoveryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RecoveryRequest>, I>>(object: I): RecoveryRequest {
    const message = createBaseRecoveryRequest()
    message.question = object.question ?? ''
    message.parentJobId = object.parentJobId ?? undefined
    message.scope = object.scope ?? ''
    message.threadId = object.threadId ?? undefined
    return message
  },
}

function createBaseResearchJobEvent(): ResearchJobEvent {
  return {
    seq: 0,
    tsMs: '0',
    kind: '',
    call: undefined,
    tool: undefined,
    status: undefined,
    params: {},
    reason: undefined,
    analyst: undefined,
    group: undefined,
    step: undefined,
    phase: undefined,
    label: undefined,
  }
}

export const ResearchJobEvent: MessageFns<ResearchJobEvent> = {
  encode(message: ResearchJobEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seq !== 0) {
      writer.uint32(8).int32(message.seq)
    }
    if (message.tsMs !== '0') {
      writer.uint32(16).int64(message.tsMs)
    }
    if (message.kind !== '') {
      writer.uint32(26).string(message.kind)
    }
    if (message.call !== undefined) {
      writer.uint32(32).int32(message.call)
    }
    if (message.tool !== undefined) {
      writer.uint32(42).string(message.tool)
    }
    if (message.status !== undefined) {
      writer.uint32(50).string(message.status)
    }
    globalThis.Object.entries(message.params).forEach(([key, value]: [string, string]) => {
      ResearchJobEvent_ParamsEntry.encode(
        { key: key as any, value },
        writer.uint32(58).fork()
      ).join()
    })
    if (message.reason !== undefined) {
      writer.uint32(66).string(message.reason)
    }
    if (message.analyst !== undefined) {
      writer.uint32(90).string(message.analyst)
    }
    if (message.group !== undefined) {
      writer.uint32(106).string(message.group)
    }
    if (message.step !== undefined) {
      writer.uint32(98).string(message.step)
    }
    if (message.phase !== undefined) {
      writer.uint32(74).string(message.phase)
    }
    if (message.label !== undefined) {
      writer.uint32(82).string(message.label)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResearchJobEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResearchJobEvent()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.seq = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.tsMs = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.kind = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.call = reader.int32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.tool = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.status = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          const entry7 = ResearchJobEvent_ParamsEntry.decode(reader, reader.uint32())
          if (entry7.value !== undefined) {
            message.params[entry7.key] = entry7.value
          }
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.reason = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.analyst = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.group = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.step = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.phase = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.label = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResearchJobEvent {
    return {
      seq: isSet(object.seq) ? globalThis.Number(object.seq) : 0,
      tsMs: isSet(object.tsMs)
        ? globalThis.String(object.tsMs)
        : isSet(object.ts_ms)
          ? globalThis.String(object.ts_ms)
          : '0',
      kind: isSet(object.kind) ? globalThis.String(object.kind) : '',
      call: isSet(object.call) ? globalThis.Number(object.call) : undefined,
      tool: isSet(object.tool) ? globalThis.String(object.tool) : undefined,
      status: isSet(object.status) ? globalThis.String(object.status) : undefined,
      params: isObject(object.params)
        ? (globalThis.Object.entries(object.params) as [string, any][]).reduce(
            (acc: { [key: string]: string }, [key, value]: [string, any]) => {
              acc[key] = globalThis.String(value)
              return acc
            },
            {}
          )
        : {},
      reason: isSet(object.reason) ? globalThis.String(object.reason) : undefined,
      analyst: isSet(object.analyst) ? globalThis.String(object.analyst) : undefined,
      group: isSet(object.group) ? globalThis.String(object.group) : undefined,
      step: isSet(object.step) ? globalThis.String(object.step) : undefined,
      phase: isSet(object.phase) ? globalThis.String(object.phase) : undefined,
      label: isSet(object.label) ? globalThis.String(object.label) : undefined,
    }
  },

  toJSON(message: ResearchJobEvent): unknown {
    const obj: any = {}
    if (message.seq !== 0) {
      obj.seq = Math.round(message.seq)
    }
    if (message.tsMs !== '0') {
      obj.tsMs = message.tsMs
    }
    if (message.kind !== '') {
      obj.kind = message.kind
    }
    if (message.call !== undefined) {
      obj.call = Math.round(message.call)
    }
    if (message.tool !== undefined) {
      obj.tool = message.tool
    }
    if (message.status !== undefined) {
      obj.status = message.status
    }
    if (message.params) {
      const entries = globalThis.Object.entries(message.params) as [string, string][]
      if (entries.length > 0) {
        obj.params = {}
        entries.forEach(([k, v]) => {
          obj.params[k] = v
        })
      }
    }
    if (message.reason !== undefined) {
      obj.reason = message.reason
    }
    if (message.analyst !== undefined) {
      obj.analyst = message.analyst
    }
    if (message.group !== undefined) {
      obj.group = message.group
    }
    if (message.step !== undefined) {
      obj.step = message.step
    }
    if (message.phase !== undefined) {
      obj.phase = message.phase
    }
    if (message.label !== undefined) {
      obj.label = message.label
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResearchJobEvent>, I>>(base?: I): ResearchJobEvent {
    return ResearchJobEvent.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResearchJobEvent>, I>>(object: I): ResearchJobEvent {
    const message = createBaseResearchJobEvent()
    message.seq = object.seq ?? 0
    message.tsMs = object.tsMs ?? '0'
    message.kind = object.kind ?? ''
    message.call = object.call ?? undefined
    message.tool = object.tool ?? undefined
    message.status = object.status ?? undefined
    message.params = (globalThis.Object.entries(object.params ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    message.reason = object.reason ?? undefined
    message.analyst = object.analyst ?? undefined
    message.group = object.group ?? undefined
    message.step = object.step ?? undefined
    message.phase = object.phase ?? undefined
    message.label = object.label ?? undefined
    return message
  },
}

function createBaseResearchJobEvent_ParamsEntry(): ResearchJobEvent_ParamsEntry {
  return { key: '', value: '' }
}

export const ResearchJobEvent_ParamsEntry: MessageFns<ResearchJobEvent_ParamsEntry> = {
  encode(
    message: ResearchJobEvent_ParamsEntry,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResearchJobEvent_ParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResearchJobEvent_ParamsEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResearchJobEvent_ParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
    }
  },

  toJSON(message: ResearchJobEvent_ParamsEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResearchJobEvent_ParamsEntry>, I>>(
    base?: I
  ): ResearchJobEvent_ParamsEntry {
    return ResearchJobEvent_ParamsEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResearchJobEvent_ParamsEntry>, I>>(
    object: I
  ): ResearchJobEvent_ParamsEntry {
    const message = createBaseResearchJobEvent_ParamsEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  },
}

function createBaseWidgetContext(): WidgetContext {
  return { metric: 0, currency: '', exchange: 0, rangeStartMs: '0', rangeEndMs: '0' }
}

export const WidgetContext: MessageFns<WidgetContext> = {
  encode(message: WidgetContext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metric !== 0) {
      writer.uint32(8).int32(message.metric)
    }
    if (message.currency !== '') {
      writer.uint32(18).string(message.currency)
    }
    if (message.exchange !== 0) {
      writer.uint32(24).int32(message.exchange)
    }
    if (message.rangeStartMs !== '0') {
      writer.uint32(32).int64(message.rangeStartMs)
    }
    if (message.rangeEndMs !== '0') {
      writer.uint32(40).int64(message.rangeEndMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WidgetContext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWidgetContext()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.metric = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currency = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.rangeStartMs = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.rangeEndMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WidgetContext {
    return {
      metric: isSet(object.metric) ? analyticsTypeFromJSON(object.metric) : 0,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      rangeStartMs: isSet(object.rangeStartMs)
        ? globalThis.String(object.rangeStartMs)
        : isSet(object.range_start_ms)
          ? globalThis.String(object.range_start_ms)
          : '0',
      rangeEndMs: isSet(object.rangeEndMs)
        ? globalThis.String(object.rangeEndMs)
        : isSet(object.range_end_ms)
          ? globalThis.String(object.range_end_ms)
          : '0',
    }
  },

  toJSON(message: WidgetContext): unknown {
    const obj: any = {}
    if (message.metric !== 0) {
      obj.metric = analyticsTypeToJSON(message.metric)
    }
    if (message.currency !== '') {
      obj.currency = message.currency
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.rangeStartMs !== '0') {
      obj.rangeStartMs = message.rangeStartMs
    }
    if (message.rangeEndMs !== '0') {
      obj.rangeEndMs = message.rangeEndMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WidgetContext>, I>>(base?: I): WidgetContext {
    return WidgetContext.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WidgetContext>, I>>(object: I): WidgetContext {
    const message = createBaseWidgetContext()
    message.metric = object.metric ?? 0
    message.currency = object.currency ?? ''
    message.exchange = object.exchange ?? 0
    message.rangeStartMs = object.rangeStartMs ?? '0'
    message.rangeEndMs = object.rangeEndMs ?? '0'
    return message
  },
}

function createBaseExplainWidgetRequest(): ExplainWidgetRequest {
  return { widget: undefined, userQuery: undefined }
}

export const ExplainWidgetRequest: MessageFns<ExplainWidgetRequest> = {
  encode(message: ExplainWidgetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.widget !== undefined) {
      WidgetContext.encode(message.widget, writer.uint32(10).fork()).join()
    }
    if (message.userQuery !== undefined) {
      writer.uint32(18).string(message.userQuery)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExplainWidgetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExplainWidgetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.widget = WidgetContext.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.userQuery = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExplainWidgetRequest {
    return {
      widget: isSet(object.widget) ? WidgetContext.fromJSON(object.widget) : undefined,
      userQuery: isSet(object.userQuery)
        ? globalThis.String(object.userQuery)
        : isSet(object.user_query)
          ? globalThis.String(object.user_query)
          : undefined,
    }
  },

  toJSON(message: ExplainWidgetRequest): unknown {
    const obj: any = {}
    if (message.widget !== undefined) {
      obj.widget = WidgetContext.toJSON(message.widget)
    }
    if (message.userQuery !== undefined) {
      obj.userQuery = message.userQuery
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExplainWidgetRequest>, I>>(base?: I): ExplainWidgetRequest {
    return ExplainWidgetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExplainWidgetRequest>, I>>(
    object: I
  ): ExplainWidgetRequest {
    const message = createBaseExplainWidgetRequest()
    message.widget =
      object.widget !== undefined && object.widget !== null
        ? WidgetContext.fromPartial(object.widget)
        : undefined
    message.userQuery = object.userQuery ?? undefined
    return message
  },
}

function createBaseExplainWidgetResponse(): ExplainWidgetResponse {
  return { report: undefined }
}

export const ExplainWidgetResponse: MessageFns<ExplainWidgetResponse> = {
  encode(message: ExplainWidgetResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.report !== undefined) {
      ResearchReport.encode(message.report, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExplainWidgetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExplainWidgetResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.report = ResearchReport.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExplainWidgetResponse {
    return { report: isSet(object.report) ? ResearchReport.fromJSON(object.report) : undefined }
  },

  toJSON(message: ExplainWidgetResponse): unknown {
    const obj: any = {}
    if (message.report !== undefined) {
      obj.report = ResearchReport.toJSON(message.report)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExplainWidgetResponse>, I>>(base?: I): ExplainWidgetResponse {
    return ExplainWidgetResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExplainWidgetResponse>, I>>(
    object: I
  ): ExplainWidgetResponse {
    const message = createBaseExplainWidgetResponse()
    message.report =
      object.report !== undefined && object.report !== null
        ? ResearchReport.fromPartial(object.report)
        : undefined
    return message
  },
}

function createBaseClassifyRequest(): ClassifyRequest {
  return {
    message: '',
    client: undefined,
    userOptIn: false,
    shadowEligible: undefined,
    threadId: undefined,
    scope: undefined,
  }
}

export const ClassifyRequest: MessageFns<ClassifyRequest> = {
  encode(message: ClassifyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== '') {
      writer.uint32(10).string(message.message)
    }
    if (message.client !== undefined) {
      writer.uint32(18).string(message.client)
    }
    if (message.userOptIn !== false) {
      writer.uint32(24).bool(message.userOptIn)
    }
    if (message.shadowEligible !== undefined) {
      writer.uint32(32).bool(message.shadowEligible)
    }
    if (message.threadId !== undefined) {
      writer.uint32(42).string(message.threadId)
    }
    if (message.scope !== undefined) {
      writer.uint32(50).string(message.scope)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClassifyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseClassifyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.message = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.client = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.userOptIn = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.shadowEligible = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.threadId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.scope = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ClassifyRequest {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      client: isSet(object.client) ? globalThis.String(object.client) : undefined,
      userOptIn: isSet(object.userOptIn)
        ? globalThis.Boolean(object.userOptIn)
        : isSet(object.user_opt_in)
          ? globalThis.Boolean(object.user_opt_in)
          : false,
      shadowEligible: isSet(object.shadowEligible)
        ? globalThis.Boolean(object.shadowEligible)
        : isSet(object.shadow_eligible)
          ? globalThis.Boolean(object.shadow_eligible)
          : undefined,
      threadId: isSet(object.threadId)
        ? globalThis.String(object.threadId)
        : isSet(object.thread_id)
          ? globalThis.String(object.thread_id)
          : undefined,
      scope: isSet(object.scope) ? globalThis.String(object.scope) : undefined,
    }
  },

  toJSON(message: ClassifyRequest): unknown {
    const obj: any = {}
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.client !== undefined) {
      obj.client = message.client
    }
    if (message.userOptIn !== false) {
      obj.userOptIn = message.userOptIn
    }
    if (message.shadowEligible !== undefined) {
      obj.shadowEligible = message.shadowEligible
    }
    if (message.threadId !== undefined) {
      obj.threadId = message.threadId
    }
    if (message.scope !== undefined) {
      obj.scope = message.scope
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ClassifyRequest>, I>>(base?: I): ClassifyRequest {
    return ClassifyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ClassifyRequest>, I>>(object: I): ClassifyRequest {
    const message = createBaseClassifyRequest()
    message.message = object.message ?? ''
    message.client = object.client ?? undefined
    message.userOptIn = object.userOptIn ?? false
    message.shadowEligible = object.shadowEligible ?? undefined
    message.threadId = object.threadId ?? undefined
    message.scope = object.scope ?? undefined
    return message
  },
}

function createBaseClassifyResponse(): ClassifyResponse {
  return {
    route: 0,
    confidence: 0,
    modelVersion: '',
    reasonCodes: [],
    requestId: '',
    userMessage: undefined,
    followup: undefined,
    clarify: undefined,
    threadId: undefined,
    proposal: undefined,
    answer: undefined,
    run: undefined,
    turnSeq: undefined,
  }
}

export const ClassifyResponse: MessageFns<ClassifyResponse> = {
  encode(message: ClassifyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.route !== 0) {
      writer.uint32(8).int32(message.route)
    }
    if (message.confidence !== 0) {
      writer.uint32(17).double(message.confidence)
    }
    if (message.modelVersion !== '') {
      writer.uint32(26).string(message.modelVersion)
    }
    for (const v of message.reasonCodes) {
      writer.uint32(34).string(v!)
    }
    if (message.requestId !== '') {
      writer.uint32(42).string(message.requestId)
    }
    if (message.userMessage !== undefined) {
      writer.uint32(50).string(message.userMessage)
    }
    if (message.followup !== undefined) {
      ClassifyFollowup.encode(message.followup, writer.uint32(58).fork()).join()
    }
    if (message.clarify !== undefined) {
      ClassifyClarify.encode(message.clarify, writer.uint32(66).fork()).join()
    }
    if (message.threadId !== undefined) {
      writer.uint32(74).string(message.threadId)
    }
    if (message.proposal !== undefined) {
      Proposal.encode(message.proposal, writer.uint32(82).fork()).join()
    }
    if (message.answer !== undefined) {
      DirectAnswer.encode(message.answer, writer.uint32(90).fork()).join()
    }
    if (message.run !== undefined) {
      ClassifyRun.encode(message.run, writer.uint32(98).fork()).join()
    }
    if (message.turnSeq !== undefined) {
      writer.uint32(104).int32(message.turnSeq)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClassifyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseClassifyResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.route = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 17) {
            break
          }

          message.confidence = reader.double()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.modelVersion = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.reasonCodes.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.requestId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.userMessage = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.followup = ClassifyFollowup.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.clarify = ClassifyClarify.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.threadId = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.proposal = Proposal.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.answer = DirectAnswer.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.run = ClassifyRun.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.turnSeq = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ClassifyResponse {
    return {
      route: isSet(object.route) ? classifyResponse_RouteFromJSON(object.route) : 0,
      confidence: isSet(object.confidence) ? globalThis.Number(object.confidence) : 0,
      modelVersion: isSet(object.modelVersion)
        ? globalThis.String(object.modelVersion)
        : isSet(object.model_version)
          ? globalThis.String(object.model_version)
          : '',
      reasonCodes: globalThis.Array.isArray(object?.reasonCodes)
        ? object.reasonCodes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.reason_codes)
          ? object.reason_codes.map((e: any) => globalThis.String(e))
          : [],
      requestId: isSet(object.requestId)
        ? globalThis.String(object.requestId)
        : isSet(object.request_id)
          ? globalThis.String(object.request_id)
          : '',
      userMessage: isSet(object.userMessage)
        ? globalThis.String(object.userMessage)
        : isSet(object.user_message)
          ? globalThis.String(object.user_message)
          : undefined,
      followup: isSet(object.followup) ? ClassifyFollowup.fromJSON(object.followup) : undefined,
      clarify: isSet(object.clarify) ? ClassifyClarify.fromJSON(object.clarify) : undefined,
      threadId: isSet(object.threadId)
        ? globalThis.String(object.threadId)
        : isSet(object.thread_id)
          ? globalThis.String(object.thread_id)
          : undefined,
      proposal: isSet(object.proposal) ? Proposal.fromJSON(object.proposal) : undefined,
      answer: isSet(object.answer) ? DirectAnswer.fromJSON(object.answer) : undefined,
      run: isSet(object.run) ? ClassifyRun.fromJSON(object.run) : undefined,
      turnSeq: isSet(object.turnSeq)
        ? globalThis.Number(object.turnSeq)
        : isSet(object.turn_seq)
          ? globalThis.Number(object.turn_seq)
          : undefined,
    }
  },

  toJSON(message: ClassifyResponse): unknown {
    const obj: any = {}
    if (message.route !== 0) {
      obj.route = classifyResponse_RouteToJSON(message.route)
    }
    if (message.confidence !== 0) {
      obj.confidence = message.confidence
    }
    if (message.modelVersion !== '') {
      obj.modelVersion = message.modelVersion
    }
    if (message.reasonCodes?.length) {
      obj.reasonCodes = message.reasonCodes
    }
    if (message.requestId !== '') {
      obj.requestId = message.requestId
    }
    if (message.userMessage !== undefined) {
      obj.userMessage = message.userMessage
    }
    if (message.followup !== undefined) {
      obj.followup = ClassifyFollowup.toJSON(message.followup)
    }
    if (message.clarify !== undefined) {
      obj.clarify = ClassifyClarify.toJSON(message.clarify)
    }
    if (message.threadId !== undefined) {
      obj.threadId = message.threadId
    }
    if (message.proposal !== undefined) {
      obj.proposal = Proposal.toJSON(message.proposal)
    }
    if (message.answer !== undefined) {
      obj.answer = DirectAnswer.toJSON(message.answer)
    }
    if (message.run !== undefined) {
      obj.run = ClassifyRun.toJSON(message.run)
    }
    if (message.turnSeq !== undefined) {
      obj.turnSeq = Math.round(message.turnSeq)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ClassifyResponse>, I>>(base?: I): ClassifyResponse {
    return ClassifyResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ClassifyResponse>, I>>(object: I): ClassifyResponse {
    const message = createBaseClassifyResponse()
    message.route = object.route ?? 0
    message.confidence = object.confidence ?? 0
    message.modelVersion = object.modelVersion ?? ''
    message.reasonCodes = object.reasonCodes?.map((e) => e) || []
    message.requestId = object.requestId ?? ''
    message.userMessage = object.userMessage ?? undefined
    message.followup =
      object.followup !== undefined && object.followup !== null
        ? ClassifyFollowup.fromPartial(object.followup)
        : undefined
    message.clarify =
      object.clarify !== undefined && object.clarify !== null
        ? ClassifyClarify.fromPartial(object.clarify)
        : undefined
    message.threadId = object.threadId ?? undefined
    message.proposal =
      object.proposal !== undefined && object.proposal !== null
        ? Proposal.fromPartial(object.proposal)
        : undefined
    message.answer =
      object.answer !== undefined && object.answer !== null
        ? DirectAnswer.fromPartial(object.answer)
        : undefined
    message.run =
      object.run !== undefined && object.run !== null
        ? ClassifyRun.fromPartial(object.run)
        : undefined
    message.turnSeq = object.turnSeq ?? undefined
    return message
  },
}

function createBaseClassifyFollowup(): ClassifyFollowup {
  return { jobId: '', deliveredAt: '' }
}

export const ClassifyFollowup: MessageFns<ClassifyFollowup> = {
  encode(message: ClassifyFollowup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== '') {
      writer.uint32(10).string(message.jobId)
    }
    if (message.deliveredAt !== '') {
      writer.uint32(18).string(message.deliveredAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClassifyFollowup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseClassifyFollowup()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.jobId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.deliveredAt = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ClassifyFollowup {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
          ? globalThis.String(object.job_id)
          : '',
      deliveredAt: isSet(object.deliveredAt)
        ? globalThis.String(object.deliveredAt)
        : isSet(object.delivered_at)
          ? globalThis.String(object.delivered_at)
          : '',
    }
  },

  toJSON(message: ClassifyFollowup): unknown {
    const obj: any = {}
    if (message.jobId !== '') {
      obj.jobId = message.jobId
    }
    if (message.deliveredAt !== '') {
      obj.deliveredAt = message.deliveredAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ClassifyFollowup>, I>>(base?: I): ClassifyFollowup {
    return ClassifyFollowup.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ClassifyFollowup>, I>>(object: I): ClassifyFollowup {
    const message = createBaseClassifyFollowup()
    message.jobId = object.jobId ?? ''
    message.deliveredAt = object.deliveredAt ?? ''
    return message
  },
}

function createBaseClassifyClarify(): ClassifyClarify {
  return { options: [] }
}

export const ClassifyClarify: MessageFns<ClassifyClarify> = {
  encode(message: ClassifyClarify, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.options) {
      ClarifyOption.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClassifyClarify {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseClassifyClarify()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.options.push(ClarifyOption.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ClassifyClarify {
    return {
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => ClarifyOption.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ClassifyClarify): unknown {
    const obj: any = {}
    if (message.options?.length) {
      obj.options = message.options.map((e) => ClarifyOption.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ClassifyClarify>, I>>(base?: I): ClassifyClarify {
    return ClassifyClarify.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ClassifyClarify>, I>>(object: I): ClassifyClarify {
    const message = createBaseClassifyClarify()
    message.options = object.options?.map((e) => ClarifyOption.fromPartial(e)) || []
    return message
  },
}

function createBaseClarifyOption(): ClarifyOption {
  return { topic: '', label: '' }
}

export const ClarifyOption: MessageFns<ClarifyOption> = {
  encode(message: ClarifyOption, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.topic !== '') {
      writer.uint32(10).string(message.topic)
    }
    if (message.label !== '') {
      writer.uint32(18).string(message.label)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClarifyOption {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseClarifyOption()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.topic = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.label = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ClarifyOption {
    return {
      topic: isSet(object.topic) ? globalThis.String(object.topic) : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
    }
  },

  toJSON(message: ClarifyOption): unknown {
    const obj: any = {}
    if (message.topic !== '') {
      obj.topic = message.topic
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ClarifyOption>, I>>(base?: I): ClarifyOption {
    return ClarifyOption.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ClarifyOption>, I>>(object: I): ClarifyOption {
    const message = createBaseClarifyOption()
    message.topic = object.topic ?? ''
    message.label = object.label ?? ''
    return message
  },
}

function createBaseProposal(): Proposal {
  return {
    proposalId: '',
    summary: '',
    topics: [],
    instruments: [],
    window: undefined,
    venues: [],
    degraded: undefined,
    answerScope: undefined,
    expiresAt: '',
    backtest: undefined,
  }
}

export const Proposal: MessageFns<Proposal> = {
  encode(message: Proposal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.proposalId !== '') {
      writer.uint32(10).string(message.proposalId)
    }
    if (message.summary !== '') {
      writer.uint32(18).string(message.summary)
    }
    for (const v of message.topics) {
      writer.uint32(26).string(v!)
    }
    for (const v of message.instruments) {
      writer.uint32(34).string(v!)
    }
    if (message.window !== undefined) {
      writer.uint32(42).string(message.window)
    }
    for (const v of message.venues) {
      writer.uint32(50).string(v!)
    }
    if (message.degraded !== undefined) {
      writer.uint32(58).string(message.degraded)
    }
    if (message.answerScope !== undefined) {
      writer.uint32(66).string(message.answerScope)
    }
    if (message.expiresAt !== '') {
      writer.uint32(74).string(message.expiresAt)
    }
    if (message.backtest !== undefined) {
      BacktestCard.encode(message.backtest, writer.uint32(82).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Proposal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseProposal()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.proposalId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.summary = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.topics.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.instruments.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.window = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.venues.push(reader.string())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.degraded = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.answerScope = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.expiresAt = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.backtest = BacktestCard.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Proposal {
    return {
      proposalId: isSet(object.proposalId)
        ? globalThis.String(object.proposalId)
        : isSet(object.proposal_id)
          ? globalThis.String(object.proposal_id)
          : '',
      summary: isSet(object.summary) ? globalThis.String(object.summary) : '',
      topics: globalThis.Array.isArray(object?.topics)
        ? object.topics.map((e: any) => globalThis.String(e))
        : [],
      instruments: globalThis.Array.isArray(object?.instruments)
        ? object.instruments.map((e: any) => globalThis.String(e))
        : [],
      window: isSet(object.window) ? globalThis.String(object.window) : undefined,
      venues: globalThis.Array.isArray(object?.venues)
        ? object.venues.map((e: any) => globalThis.String(e))
        : [],
      degraded: isSet(object.degraded) ? globalThis.String(object.degraded) : undefined,
      answerScope: isSet(object.answerScope)
        ? globalThis.String(object.answerScope)
        : isSet(object.answer_scope)
          ? globalThis.String(object.answer_scope)
          : undefined,
      expiresAt: isSet(object.expiresAt)
        ? globalThis.String(object.expiresAt)
        : isSet(object.expires_at)
          ? globalThis.String(object.expires_at)
          : '',
      backtest: isSet(object.backtest) ? BacktestCard.fromJSON(object.backtest) : undefined,
    }
  },

  toJSON(message: Proposal): unknown {
    const obj: any = {}
    if (message.proposalId !== '') {
      obj.proposalId = message.proposalId
    }
    if (message.summary !== '') {
      obj.summary = message.summary
    }
    if (message.topics?.length) {
      obj.topics = message.topics
    }
    if (message.instruments?.length) {
      obj.instruments = message.instruments
    }
    if (message.window !== undefined) {
      obj.window = message.window
    }
    if (message.venues?.length) {
      obj.venues = message.venues
    }
    if (message.degraded !== undefined) {
      obj.degraded = message.degraded
    }
    if (message.answerScope !== undefined) {
      obj.answerScope = message.answerScope
    }
    if (message.expiresAt !== '') {
      obj.expiresAt = message.expiresAt
    }
    if (message.backtest !== undefined) {
      obj.backtest = BacktestCard.toJSON(message.backtest)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Proposal>, I>>(base?: I): Proposal {
    return Proposal.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Proposal>, I>>(object: I): Proposal {
    const message = createBaseProposal()
    message.proposalId = object.proposalId ?? ''
    message.summary = object.summary ?? ''
    message.topics = object.topics?.map((e) => e) || []
    message.instruments = object.instruments?.map((e) => e) || []
    message.window = object.window ?? undefined
    message.venues = object.venues?.map((e) => e) || []
    message.degraded = object.degraded ?? undefined
    message.answerScope = object.answerScope ?? undefined
    message.expiresAt = object.expiresAt ?? ''
    message.backtest =
      object.backtest !== undefined && object.backtest !== null
        ? BacktestCard.fromPartial(object.backtest)
        : undefined
    return message
  },
}

function createBaseBacktestCard(): BacktestCard {
  return { specVersion: 0, lines: [], editable: [], assumptions: [], warnings: [] }
}

export const BacktestCard: MessageFns<BacktestCard> = {
  encode(message: BacktestCard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.specVersion !== 0) {
      writer.uint32(8).int32(message.specVersion)
    }
    for (const v of message.lines) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.editable) {
      BacktestEditable.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.assumptions) {
      writer.uint32(34).string(v!)
    }
    for (const v of message.warnings) {
      writer.uint32(42).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BacktestCard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBacktestCard()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.specVersion = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.lines.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.editable.push(BacktestEditable.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.assumptions.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.warnings.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BacktestCard {
    return {
      specVersion: isSet(object.specVersion)
        ? globalThis.Number(object.specVersion)
        : isSet(object.spec_version)
          ? globalThis.Number(object.spec_version)
          : 0,
      lines: globalThis.Array.isArray(object?.lines)
        ? object.lines.map((e: any) => globalThis.String(e))
        : [],
      editable: globalThis.Array.isArray(object?.editable)
        ? object.editable.map((e: any) => BacktestEditable.fromJSON(e))
        : [],
      assumptions: globalThis.Array.isArray(object?.assumptions)
        ? object.assumptions.map((e: any) => globalThis.String(e))
        : [],
      warnings: globalThis.Array.isArray(object?.warnings)
        ? object.warnings.map((e: any) => globalThis.String(e))
        : [],
    }
  },

  toJSON(message: BacktestCard): unknown {
    const obj: any = {}
    if (message.specVersion !== 0) {
      obj.specVersion = Math.round(message.specVersion)
    }
    if (message.lines?.length) {
      obj.lines = message.lines
    }
    if (message.editable?.length) {
      obj.editable = message.editable.map((e) => BacktestEditable.toJSON(e))
    }
    if (message.assumptions?.length) {
      obj.assumptions = message.assumptions
    }
    if (message.warnings?.length) {
      obj.warnings = message.warnings
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BacktestCard>, I>>(base?: I): BacktestCard {
    return BacktestCard.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BacktestCard>, I>>(object: I): BacktestCard {
    const message = createBaseBacktestCard()
    message.specVersion = object.specVersion ?? 0
    message.lines = object.lines?.map((e) => e) || []
    message.editable = object.editable?.map((e) => BacktestEditable.fromPartial(e)) || []
    message.assumptions = object.assumptions?.map((e) => e) || []
    message.warnings = object.warnings?.map((e) => e) || []
    return message
  },
}

function createBaseBacktestEditable(): BacktestEditable {
  return {
    path: '',
    label: '',
    value: '',
    kind: '',
    options: [],
    origin: '',
    min: undefined,
    max: undefined,
    unit: undefined,
  }
}

export const BacktestEditable: MessageFns<BacktestEditable> = {
  encode(message: BacktestEditable, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== '') {
      writer.uint32(10).string(message.path)
    }
    if (message.label !== '') {
      writer.uint32(18).string(message.label)
    }
    if (message.value !== '') {
      writer.uint32(26).string(message.value)
    }
    if (message.kind !== '') {
      writer.uint32(34).string(message.kind)
    }
    for (const v of message.options) {
      writer.uint32(42).string(v!)
    }
    if (message.origin !== '') {
      writer.uint32(50).string(message.origin)
    }
    if (message.min !== undefined) {
      writer.uint32(58).string(message.min)
    }
    if (message.max !== undefined) {
      writer.uint32(66).string(message.max)
    }
    if (message.unit !== undefined) {
      writer.uint32(74).string(message.unit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BacktestEditable {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBacktestEditable()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.path = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.value = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.kind = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.options.push(reader.string())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.origin = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.min = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.max = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.unit = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BacktestEditable {
    return {
      path: isSet(object.path) ? globalThis.String(object.path) : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      kind: isSet(object.kind) ? globalThis.String(object.kind) : '',
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => globalThis.String(e))
        : [],
      origin: isSet(object.origin) ? globalThis.String(object.origin) : '',
      min: isSet(object.min) ? globalThis.String(object.min) : undefined,
      max: isSet(object.max) ? globalThis.String(object.max) : undefined,
      unit: isSet(object.unit) ? globalThis.String(object.unit) : undefined,
    }
  },

  toJSON(message: BacktestEditable): unknown {
    const obj: any = {}
    if (message.path !== '') {
      obj.path = message.path
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.kind !== '') {
      obj.kind = message.kind
    }
    if (message.options?.length) {
      obj.options = message.options
    }
    if (message.origin !== '') {
      obj.origin = message.origin
    }
    if (message.min !== undefined) {
      obj.min = message.min
    }
    if (message.max !== undefined) {
      obj.max = message.max
    }
    if (message.unit !== undefined) {
      obj.unit = message.unit
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BacktestEditable>, I>>(base?: I): BacktestEditable {
    return BacktestEditable.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BacktestEditable>, I>>(object: I): BacktestEditable {
    const message = createBaseBacktestEditable()
    message.path = object.path ?? ''
    message.label = object.label ?? ''
    message.value = object.value ?? ''
    message.kind = object.kind ?? ''
    message.options = object.options?.map((e) => e) || []
    message.origin = object.origin ?? ''
    message.min = object.min ?? undefined
    message.max = object.max ?? undefined
    message.unit = object.unit ?? undefined
    return message
  },
}

function createBaseClassifyRun(): ClassifyRun {
  return { jobId: '' }
}

export const ClassifyRun: MessageFns<ClassifyRun> = {
  encode(message: ClassifyRun, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== '') {
      writer.uint32(10).string(message.jobId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClassifyRun {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseClassifyRun()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.jobId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ClassifyRun {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
          ? globalThis.String(object.job_id)
          : '',
    }
  },

  toJSON(message: ClassifyRun): unknown {
    const obj: any = {}
    if (message.jobId !== '') {
      obj.jobId = message.jobId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ClassifyRun>, I>>(base?: I): ClassifyRun {
    return ClassifyRun.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ClassifyRun>, I>>(object: I): ClassifyRun {
    const message = createBaseClassifyRun()
    message.jobId = object.jobId ?? ''
    return message
  },
}

function createBaseDirectAnswer(): DirectAnswer {
  return { text: '', sources: [], sourceJobId: undefined, modelVersion: '' }
}

export const DirectAnswer: MessageFns<DirectAnswer> = {
  encode(message: DirectAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== '') {
      writer.uint32(10).string(message.text)
    }
    for (const v of message.sources) {
      DirectAnswerSource.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.sourceJobId !== undefined) {
      writer.uint32(26).string(message.sourceJobId)
    }
    if (message.modelVersion !== '') {
      writer.uint32(34).string(message.modelVersion)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DirectAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDirectAnswer()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.text = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.sources.push(DirectAnswerSource.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sourceJobId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.modelVersion = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DirectAnswer {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : '',
      sources: globalThis.Array.isArray(object?.sources)
        ? object.sources.map((e: any) => DirectAnswerSource.fromJSON(e))
        : [],
      sourceJobId: isSet(object.sourceJobId)
        ? globalThis.String(object.sourceJobId)
        : isSet(object.source_job_id)
          ? globalThis.String(object.source_job_id)
          : undefined,
      modelVersion: isSet(object.modelVersion)
        ? globalThis.String(object.modelVersion)
        : isSet(object.model_version)
          ? globalThis.String(object.model_version)
          : '',
    }
  },

  toJSON(message: DirectAnswer): unknown {
    const obj: any = {}
    if (message.text !== '') {
      obj.text = message.text
    }
    if (message.sources?.length) {
      obj.sources = message.sources.map((e) => DirectAnswerSource.toJSON(e))
    }
    if (message.sourceJobId !== undefined) {
      obj.sourceJobId = message.sourceJobId
    }
    if (message.modelVersion !== '') {
      obj.modelVersion = message.modelVersion
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DirectAnswer>, I>>(base?: I): DirectAnswer {
    return DirectAnswer.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DirectAnswer>, I>>(object: I): DirectAnswer {
    const message = createBaseDirectAnswer()
    message.text = object.text ?? ''
    message.sources = object.sources?.map((e) => DirectAnswerSource.fromPartial(e)) || []
    message.sourceJobId = object.sourceJobId ?? undefined
    message.modelVersion = object.modelVersion ?? ''
    return message
  },
}

function createBaseDirectAnswerSource(): DirectAnswerSource {
  return { reportBlock: undefined, turn: undefined }
}

export const DirectAnswerSource: MessageFns<DirectAnswerSource> = {
  encode(message: DirectAnswerSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reportBlock !== undefined) {
      DirectAnswerBlockSource.encode(message.reportBlock, writer.uint32(10).fork()).join()
    }
    if (message.turn !== undefined) {
      DirectAnswerTurnSource.encode(message.turn, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DirectAnswerSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDirectAnswerSource()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.reportBlock = DirectAnswerBlockSource.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.turn = DirectAnswerTurnSource.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DirectAnswerSource {
    return {
      reportBlock: isSet(object.reportBlock)
        ? DirectAnswerBlockSource.fromJSON(object.reportBlock)
        : isSet(object.report_block)
          ? DirectAnswerBlockSource.fromJSON(object.report_block)
          : undefined,
      turn: isSet(object.turn) ? DirectAnswerTurnSource.fromJSON(object.turn) : undefined,
    }
  },

  toJSON(message: DirectAnswerSource): unknown {
    const obj: any = {}
    if (message.reportBlock !== undefined) {
      obj.reportBlock = DirectAnswerBlockSource.toJSON(message.reportBlock)
    }
    if (message.turn !== undefined) {
      obj.turn = DirectAnswerTurnSource.toJSON(message.turn)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DirectAnswerSource>, I>>(base?: I): DirectAnswerSource {
    return DirectAnswerSource.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DirectAnswerSource>, I>>(object: I): DirectAnswerSource {
    const message = createBaseDirectAnswerSource()
    message.reportBlock =
      object.reportBlock !== undefined && object.reportBlock !== null
        ? DirectAnswerBlockSource.fromPartial(object.reportBlock)
        : undefined
    message.turn =
      object.turn !== undefined && object.turn !== null
        ? DirectAnswerTurnSource.fromPartial(object.turn)
        : undefined
    return message
  },
}

function createBaseDirectAnswerBlockSource(): DirectAnswerBlockSource {
  return { block: 0, section: '' }
}

export const DirectAnswerBlockSource: MessageFns<DirectAnswerBlockSource> = {
  encode(
    message: DirectAnswerBlockSource,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.block !== 0) {
      writer.uint32(8).int32(message.block)
    }
    if (message.section !== '') {
      writer.uint32(18).string(message.section)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DirectAnswerBlockSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDirectAnswerBlockSource()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.block = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.section = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DirectAnswerBlockSource {
    return {
      block: isSet(object.block) ? globalThis.Number(object.block) : 0,
      section: isSet(object.section) ? globalThis.String(object.section) : '',
    }
  },

  toJSON(message: DirectAnswerBlockSource): unknown {
    const obj: any = {}
    if (message.block !== 0) {
      obj.block = Math.round(message.block)
    }
    if (message.section !== '') {
      obj.section = message.section
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DirectAnswerBlockSource>, I>>(
    base?: I
  ): DirectAnswerBlockSource {
    return DirectAnswerBlockSource.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DirectAnswerBlockSource>, I>>(
    object: I
  ): DirectAnswerBlockSource {
    const message = createBaseDirectAnswerBlockSource()
    message.block = object.block ?? 0
    message.section = object.section ?? ''
    return message
  },
}

function createBaseDirectAnswerTurnSource(): DirectAnswerTurnSource {
  return { seq: 0 }
}

export const DirectAnswerTurnSource: MessageFns<DirectAnswerTurnSource> = {
  encode(message: DirectAnswerTurnSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seq !== 0) {
      writer.uint32(8).int32(message.seq)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DirectAnswerTurnSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDirectAnswerTurnSource()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.seq = reader.int32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DirectAnswerTurnSource {
    return { seq: isSet(object.seq) ? globalThis.Number(object.seq) : 0 }
  },

  toJSON(message: DirectAnswerTurnSource): unknown {
    const obj: any = {}
    if (message.seq !== 0) {
      obj.seq = Math.round(message.seq)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DirectAnswerTurnSource>, I>>(
    base?: I
  ): DirectAnswerTurnSource {
    return DirectAnswerTurnSource.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DirectAnswerTurnSource>, I>>(
    object: I
  ): DirectAnswerTurnSource {
    const message = createBaseDirectAnswerTurnSource()
    message.seq = object.seq ?? 0
    return message
  },
}

function createBaseHomeBriefRequest(): HomeBriefRequest {
  return { cards: [], ideas: [], book: undefined, refresh: false }
}

export const HomeBriefRequest: MessageFns<HomeBriefRequest> = {
  encode(message: HomeBriefRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.cards) {
      HomeBriefCard.encode(v!, writer.uint32(10).fork()).join()
    }
    for (const v of message.ideas) {
      HomeBriefIdea.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.book !== undefined) {
      HomeBriefBook.encode(message.book, writer.uint32(26).fork()).join()
    }
    if (message.refresh !== false) {
      writer.uint32(32).bool(message.refresh)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.cards.push(HomeBriefCard.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.ideas.push(HomeBriefIdea.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.book = HomeBriefBook.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.refresh = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefRequest {
    return {
      cards: globalThis.Array.isArray(object?.cards)
        ? object.cards.map((e: any) => HomeBriefCard.fromJSON(e))
        : [],
      ideas: globalThis.Array.isArray(object?.ideas)
        ? object.ideas.map((e: any) => HomeBriefIdea.fromJSON(e))
        : [],
      book: isSet(object.book) ? HomeBriefBook.fromJSON(object.book) : undefined,
      refresh: isSet(object.refresh) ? globalThis.Boolean(object.refresh) : false,
    }
  },

  toJSON(message: HomeBriefRequest): unknown {
    const obj: any = {}
    if (message.cards?.length) {
      obj.cards = message.cards.map((e) => HomeBriefCard.toJSON(e))
    }
    if (message.ideas?.length) {
      obj.ideas = message.ideas.map((e) => HomeBriefIdea.toJSON(e))
    }
    if (message.book !== undefined) {
      obj.book = HomeBriefBook.toJSON(message.book)
    }
    if (message.refresh !== false) {
      obj.refresh = message.refresh
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefRequest>, I>>(base?: I): HomeBriefRequest {
    return HomeBriefRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefRequest>, I>>(object: I): HomeBriefRequest {
    const message = createBaseHomeBriefRequest()
    message.cards = object.cards?.map((e) => HomeBriefCard.fromPartial(e)) || []
    message.ideas = object.ideas?.map((e) => HomeBriefIdea.fromPartial(e)) || []
    message.book =
      object.book !== undefined && object.book !== null
        ? HomeBriefBook.fromPartial(object.book)
        : undefined
    message.refresh = object.refresh ?? false
    return message
  },
}

function createBaseHomeBriefCard(): HomeBriefCard {
  return { id: '', kind: 0, asset: undefined, line: '' }
}

export const HomeBriefCard: MessageFns<HomeBriefCard> = {
  encode(message: HomeBriefCard, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind)
    }
    if (message.asset !== undefined) {
      writer.uint32(26).string(message.asset)
    }
    if (message.line !== '') {
      writer.uint32(34).string(message.line)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefCard {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefCard()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.line = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefCard {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      kind: isSet(object.kind) ? homeBriefCard_KindFromJSON(object.kind) : 0,
      asset: isSet(object.asset) ? globalThis.String(object.asset) : undefined,
      line: isSet(object.line) ? globalThis.String(object.line) : '',
    }
  },

  toJSON(message: HomeBriefCard): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.kind !== 0) {
      obj.kind = homeBriefCard_KindToJSON(message.kind)
    }
    if (message.asset !== undefined) {
      obj.asset = message.asset
    }
    if (message.line !== '') {
      obj.line = message.line
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefCard>, I>>(base?: I): HomeBriefCard {
    return HomeBriefCard.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefCard>, I>>(object: I): HomeBriefCard {
    const message = createBaseHomeBriefCard()
    message.id = object.id ?? ''
    message.kind = object.kind ?? 0
    message.asset = object.asset ?? undefined
    message.line = object.line ?? ''
    return message
  },
}

function createBaseHomeBriefIdea(): HomeBriefIdea {
  return { id: '', kind: 0, symbol: '', asset: '', facts: undefined }
}

export const HomeBriefIdea: MessageFns<HomeBriefIdea> = {
  encode(message: HomeBriefIdea, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.asset !== '') {
      writer.uint32(34).string(message.asset)
    }
    if (message.facts !== undefined) {
      HomeBriefIdeaFacts.encode(message.facts, writer.uint32(42).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefIdea {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefIdea()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.facts = HomeBriefIdeaFacts.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefIdea {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      kind: isSet(object.kind) ? homeBriefIdea_KindFromJSON(object.kind) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      facts: isSet(object.facts) ? HomeBriefIdeaFacts.fromJSON(object.facts) : undefined,
    }
  },

  toJSON(message: HomeBriefIdea): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.kind !== 0) {
      obj.kind = homeBriefIdea_KindToJSON(message.kind)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.facts !== undefined) {
      obj.facts = HomeBriefIdeaFacts.toJSON(message.facts)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefIdea>, I>>(base?: I): HomeBriefIdea {
    return HomeBriefIdea.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefIdea>, I>>(object: I): HomeBriefIdea {
    const message = createBaseHomeBriefIdea()
    message.id = object.id ?? ''
    message.kind = object.kind ?? 0
    message.symbol = object.symbol ?? ''
    message.asset = object.asset ?? ''
    message.facts =
      object.facts !== undefined && object.facts !== null
        ? HomeBriefIdeaFacts.fromPartial(object.facts)
        : undefined
    return message
  },
}

function createBaseHomeBriefIdeaFacts(): HomeBriefIdeaFacts {
  return {
    leverage: undefined,
    liquidationDistance: undefined,
    pnl: undefined,
    hoursToExpiry: undefined,
    fundingApr: undefined,
    bookShare: undefined,
  }
}

export const HomeBriefIdeaFacts: MessageFns<HomeBriefIdeaFacts> = {
  encode(message: HomeBriefIdeaFacts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.leverage !== undefined) {
      writer.uint32(10).string(message.leverage)
    }
    if (message.liquidationDistance !== undefined) {
      writer.uint32(18).string(message.liquidationDistance)
    }
    if (message.pnl !== undefined) {
      writer.uint32(26).string(message.pnl)
    }
    if (message.hoursToExpiry !== undefined) {
      writer.uint32(34).string(message.hoursToExpiry)
    }
    if (message.fundingApr !== undefined) {
      writer.uint32(42).string(message.fundingApr)
    }
    if (message.bookShare !== undefined) {
      writer.uint32(50).string(message.bookShare)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefIdeaFacts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefIdeaFacts()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.leverage = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.liquidationDistance = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.pnl = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.hoursToExpiry = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.fundingApr = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.bookShare = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefIdeaFacts {
    return {
      leverage: isSet(object.leverage) ? globalThis.String(object.leverage) : undefined,
      liquidationDistance: isSet(object.liquidationDistance)
        ? globalThis.String(object.liquidationDistance)
        : isSet(object.liquidation_distance)
          ? globalThis.String(object.liquidation_distance)
          : undefined,
      pnl: isSet(object.pnl) ? globalThis.String(object.pnl) : undefined,
      hoursToExpiry: isSet(object.hoursToExpiry)
        ? globalThis.String(object.hoursToExpiry)
        : isSet(object.hours_to_expiry)
          ? globalThis.String(object.hours_to_expiry)
          : undefined,
      fundingApr: isSet(object.fundingApr)
        ? globalThis.String(object.fundingApr)
        : isSet(object.funding_apr)
          ? globalThis.String(object.funding_apr)
          : undefined,
      bookShare: isSet(object.bookShare)
        ? globalThis.String(object.bookShare)
        : isSet(object.book_share)
          ? globalThis.String(object.book_share)
          : undefined,
    }
  },

  toJSON(message: HomeBriefIdeaFacts): unknown {
    const obj: any = {}
    if (message.leverage !== undefined) {
      obj.leverage = message.leverage
    }
    if (message.liquidationDistance !== undefined) {
      obj.liquidationDistance = message.liquidationDistance
    }
    if (message.pnl !== undefined) {
      obj.pnl = message.pnl
    }
    if (message.hoursToExpiry !== undefined) {
      obj.hoursToExpiry = message.hoursToExpiry
    }
    if (message.fundingApr !== undefined) {
      obj.fundingApr = message.fundingApr
    }
    if (message.bookShare !== undefined) {
      obj.bookShare = message.bookShare
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefIdeaFacts>, I>>(base?: I): HomeBriefIdeaFacts {
    return HomeBriefIdeaFacts.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefIdeaFacts>, I>>(object: I): HomeBriefIdeaFacts {
    const message = createBaseHomeBriefIdeaFacts()
    message.leverage = object.leverage ?? undefined
    message.liquidationDistance = object.liquidationDistance ?? undefined
    message.pnl = object.pnl ?? undefined
    message.hoursToExpiry = object.hoursToExpiry ?? undefined
    message.fundingApr = object.fundingApr ?? undefined
    message.bookShare = object.bookShare ?? undefined
    return message
  },
}

function createBaseHomeBriefBook(): HomeBriefBook {
  return { openOrderCount: undefined, positions: [] }
}

export const HomeBriefBook: MessageFns<HomeBriefBook> = {
  encode(message: HomeBriefBook, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.openOrderCount !== undefined) {
      writer.uint32(8).int32(message.openOrderCount)
    }
    for (const v of message.positions) {
      HomeBriefPosition.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefBook {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefBook()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.openOrderCount = reader.int32()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.positions.push(HomeBriefPosition.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefBook {
    return {
      openOrderCount: isSet(object.openOrderCount)
        ? globalThis.Number(object.openOrderCount)
        : isSet(object.open_order_count)
          ? globalThis.Number(object.open_order_count)
          : undefined,
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => HomeBriefPosition.fromJSON(e))
        : [],
    }
  },

  toJSON(message: HomeBriefBook): unknown {
    const obj: any = {}
    if (message.openOrderCount !== undefined) {
      obj.openOrderCount = Math.round(message.openOrderCount)
    }
    if (message.positions?.length) {
      obj.positions = message.positions.map((e) => HomeBriefPosition.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefBook>, I>>(base?: I): HomeBriefBook {
    return HomeBriefBook.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefBook>, I>>(object: I): HomeBriefBook {
    const message = createBaseHomeBriefBook()
    message.openOrderCount = object.openOrderCount ?? undefined
    message.positions = object.positions?.map((e) => HomeBriefPosition.fromPartial(e)) || []
    return message
  },
}

function createBaseHomeBriefPosition(): HomeBriefPosition {
  return {
    symbol: '',
    side: '',
    leverage: undefined,
    liquidationDistance: undefined,
    pnl: undefined,
    bookShare: undefined,
  }
}

export const HomeBriefPosition: MessageFns<HomeBriefPosition> = {
  encode(message: HomeBriefPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.side !== '') {
      writer.uint32(18).string(message.side)
    }
    if (message.leverage !== undefined) {
      writer.uint32(26).string(message.leverage)
    }
    if (message.liquidationDistance !== undefined) {
      writer.uint32(34).string(message.liquidationDistance)
    }
    if (message.pnl !== undefined) {
      writer.uint32(42).string(message.pnl)
    }
    if (message.bookShare !== undefined) {
      writer.uint32(50).string(message.bookShare)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefPosition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.side = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.leverage = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.liquidationDistance = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.pnl = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.bookShare = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefPosition {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      side: isSet(object.side) ? globalThis.String(object.side) : '',
      leverage: isSet(object.leverage) ? globalThis.String(object.leverage) : undefined,
      liquidationDistance: isSet(object.liquidationDistance)
        ? globalThis.String(object.liquidationDistance)
        : isSet(object.liquidation_distance)
          ? globalThis.String(object.liquidation_distance)
          : undefined,
      pnl: isSet(object.pnl) ? globalThis.String(object.pnl) : undefined,
      bookShare: isSet(object.bookShare)
        ? globalThis.String(object.bookShare)
        : isSet(object.book_share)
          ? globalThis.String(object.book_share)
          : undefined,
    }
  },

  toJSON(message: HomeBriefPosition): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.side !== '') {
      obj.side = message.side
    }
    if (message.leverage !== undefined) {
      obj.leverage = message.leverage
    }
    if (message.liquidationDistance !== undefined) {
      obj.liquidationDistance = message.liquidationDistance
    }
    if (message.pnl !== undefined) {
      obj.pnl = message.pnl
    }
    if (message.bookShare !== undefined) {
      obj.bookShare = message.bookShare
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefPosition>, I>>(base?: I): HomeBriefPosition {
    return HomeBriefPosition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefPosition>, I>>(object: I): HomeBriefPosition {
    const message = createBaseHomeBriefPosition()
    message.symbol = object.symbol ?? ''
    message.side = object.side ?? ''
    message.leverage = object.leverage ?? undefined
    message.liquidationDistance = object.liquidationDistance ?? undefined
    message.pnl = object.pnl ?? undefined
    message.bookShare = object.bookShare ?? undefined
    return message
  },
}

function createBaseHomeBriefResponse(): HomeBriefResponse {
  return {
    brief: undefined,
    cardNotes: [],
    ideaReasoning: [],
    omitted: [],
    omittedSections: [],
    generatedAt: '',
    cached: false,
    modelVersion: '',
    requestId: '',
  }
}

export const HomeBriefResponse: MessageFns<HomeBriefResponse> = {
  encode(message: HomeBriefResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.brief !== undefined) {
      HomeBriefSections.encode(message.brief, writer.uint32(10).fork()).join()
    }
    for (const v of message.cardNotes) {
      HomeBriefCardNote.encode(v!, writer.uint32(18).fork()).join()
    }
    for (const v of message.ideaReasoning) {
      HomeBriefIdeaReasoning.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.omitted) {
      HomeBriefOmission.encode(v!, writer.uint32(34).fork()).join()
    }
    for (const v of message.omittedSections) {
      HomeBriefSectionOmission.encode(v!, writer.uint32(42).fork()).join()
    }
    if (message.generatedAt !== '') {
      writer.uint32(50).string(message.generatedAt)
    }
    if (message.cached !== false) {
      writer.uint32(56).bool(message.cached)
    }
    if (message.modelVersion !== '') {
      writer.uint32(66).string(message.modelVersion)
    }
    if (message.requestId !== '') {
      writer.uint32(74).string(message.requestId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.brief = HomeBriefSections.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.cardNotes.push(HomeBriefCardNote.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.ideaReasoning.push(HomeBriefIdeaReasoning.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.omitted.push(HomeBriefOmission.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.omittedSections.push(HomeBriefSectionOmission.decode(reader, reader.uint32()))
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.generatedAt = reader.string()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.cached = reader.bool()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.modelVersion = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.requestId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefResponse {
    return {
      brief: isSet(object.brief) ? HomeBriefSections.fromJSON(object.brief) : undefined,
      cardNotes: globalThis.Array.isArray(object?.cardNotes)
        ? object.cardNotes.map((e: any) => HomeBriefCardNote.fromJSON(e))
        : globalThis.Array.isArray(object?.card_notes)
          ? object.card_notes.map((e: any) => HomeBriefCardNote.fromJSON(e))
          : [],
      ideaReasoning: globalThis.Array.isArray(object?.ideaReasoning)
        ? object.ideaReasoning.map((e: any) => HomeBriefIdeaReasoning.fromJSON(e))
        : globalThis.Array.isArray(object?.idea_reasoning)
          ? object.idea_reasoning.map((e: any) => HomeBriefIdeaReasoning.fromJSON(e))
          : [],
      omitted: globalThis.Array.isArray(object?.omitted)
        ? object.omitted.map((e: any) => HomeBriefOmission.fromJSON(e))
        : [],
      omittedSections: globalThis.Array.isArray(object?.omittedSections)
        ? object.omittedSections.map((e: any) => HomeBriefSectionOmission.fromJSON(e))
        : globalThis.Array.isArray(object?.omitted_sections)
          ? object.omitted_sections.map((e: any) => HomeBriefSectionOmission.fromJSON(e))
          : [],
      generatedAt: isSet(object.generatedAt)
        ? globalThis.String(object.generatedAt)
        : isSet(object.generated_at)
          ? globalThis.String(object.generated_at)
          : '',
      cached: isSet(object.cached) ? globalThis.Boolean(object.cached) : false,
      modelVersion: isSet(object.modelVersion)
        ? globalThis.String(object.modelVersion)
        : isSet(object.model_version)
          ? globalThis.String(object.model_version)
          : '',
      requestId: isSet(object.requestId)
        ? globalThis.String(object.requestId)
        : isSet(object.request_id)
          ? globalThis.String(object.request_id)
          : '',
    }
  },

  toJSON(message: HomeBriefResponse): unknown {
    const obj: any = {}
    if (message.brief !== undefined) {
      obj.brief = HomeBriefSections.toJSON(message.brief)
    }
    if (message.cardNotes?.length) {
      obj.cardNotes = message.cardNotes.map((e) => HomeBriefCardNote.toJSON(e))
    }
    if (message.ideaReasoning?.length) {
      obj.ideaReasoning = message.ideaReasoning.map((e) => HomeBriefIdeaReasoning.toJSON(e))
    }
    if (message.omitted?.length) {
      obj.omitted = message.omitted.map((e) => HomeBriefOmission.toJSON(e))
    }
    if (message.omittedSections?.length) {
      obj.omittedSections = message.omittedSections.map((e) => HomeBriefSectionOmission.toJSON(e))
    }
    if (message.generatedAt !== '') {
      obj.generatedAt = message.generatedAt
    }
    if (message.cached !== false) {
      obj.cached = message.cached
    }
    if (message.modelVersion !== '') {
      obj.modelVersion = message.modelVersion
    }
    if (message.requestId !== '') {
      obj.requestId = message.requestId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefResponse>, I>>(base?: I): HomeBriefResponse {
    return HomeBriefResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefResponse>, I>>(object: I): HomeBriefResponse {
    const message = createBaseHomeBriefResponse()
    message.brief =
      object.brief !== undefined && object.brief !== null
        ? HomeBriefSections.fromPartial(object.brief)
        : undefined
    message.cardNotes = object.cardNotes?.map((e) => HomeBriefCardNote.fromPartial(e)) || []
    message.ideaReasoning =
      object.ideaReasoning?.map((e) => HomeBriefIdeaReasoning.fromPartial(e)) || []
    message.omitted = object.omitted?.map((e) => HomeBriefOmission.fromPartial(e)) || []
    message.omittedSections =
      object.omittedSections?.map((e) => HomeBriefSectionOmission.fromPartial(e)) || []
    message.generatedAt = object.generatedAt ?? ''
    message.cached = object.cached ?? false
    message.modelVersion = object.modelVersion ?? ''
    message.requestId = object.requestId ?? ''
    return message
  },
}

function createBaseHomeBriefSections(): HomeBriefSections {
  return { changed: undefined, meaning: undefined, watch: undefined }
}

export const HomeBriefSections: MessageFns<HomeBriefSections> = {
  encode(message: HomeBriefSections, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.changed !== undefined) {
      HomeBriefText.encode(message.changed, writer.uint32(10).fork()).join()
    }
    if (message.meaning !== undefined) {
      HomeBriefText.encode(message.meaning, writer.uint32(18).fork()).join()
    }
    if (message.watch !== undefined) {
      HomeBriefText.encode(message.watch, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefSections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefSections()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.changed = HomeBriefText.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.meaning = HomeBriefText.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.watch = HomeBriefText.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefSections {
    return {
      changed: isSet(object.changed) ? HomeBriefText.fromJSON(object.changed) : undefined,
      meaning: isSet(object.meaning) ? HomeBriefText.fromJSON(object.meaning) : undefined,
      watch: isSet(object.watch) ? HomeBriefText.fromJSON(object.watch) : undefined,
    }
  },

  toJSON(message: HomeBriefSections): unknown {
    const obj: any = {}
    if (message.changed !== undefined) {
      obj.changed = HomeBriefText.toJSON(message.changed)
    }
    if (message.meaning !== undefined) {
      obj.meaning = HomeBriefText.toJSON(message.meaning)
    }
    if (message.watch !== undefined) {
      obj.watch = HomeBriefText.toJSON(message.watch)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefSections>, I>>(base?: I): HomeBriefSections {
    return HomeBriefSections.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefSections>, I>>(object: I): HomeBriefSections {
    const message = createBaseHomeBriefSections()
    message.changed =
      object.changed !== undefined && object.changed !== null
        ? HomeBriefText.fromPartial(object.changed)
        : undefined
    message.meaning =
      object.meaning !== undefined && object.meaning !== null
        ? HomeBriefText.fromPartial(object.meaning)
        : undefined
    message.watch =
      object.watch !== undefined && object.watch !== null
        ? HomeBriefText.fromPartial(object.watch)
        : undefined
    return message
  },
}

function createBaseHomeBriefText(): HomeBriefText {
  return { text: '', quotes: [] }
}

export const HomeBriefText: MessageFns<HomeBriefText> = {
  encode(message: HomeBriefText, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== '') {
      writer.uint32(10).string(message.text)
    }
    for (const v of message.quotes) {
      HomeBriefQuote.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefText {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefText()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.text = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.quotes.push(HomeBriefQuote.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefText {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : '',
      quotes: globalThis.Array.isArray(object?.quotes)
        ? object.quotes.map((e: any) => HomeBriefQuote.fromJSON(e))
        : [],
    }
  },

  toJSON(message: HomeBriefText): unknown {
    const obj: any = {}
    if (message.text !== '') {
      obj.text = message.text
    }
    if (message.quotes?.length) {
      obj.quotes = message.quotes.map((e) => HomeBriefQuote.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefText>, I>>(base?: I): HomeBriefText {
    return HomeBriefText.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefText>, I>>(object: I): HomeBriefText {
    const message = createBaseHomeBriefText()
    message.text = object.text ?? ''
    message.quotes = object.quotes?.map((e) => HomeBriefQuote.fromPartial(e)) || []
    return message
  },
}

function createBaseHomeBriefQuote(): HomeBriefQuote {
  return { src: '', text: '' }
}

export const HomeBriefQuote: MessageFns<HomeBriefQuote> = {
  encode(message: HomeBriefQuote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.src !== '') {
      writer.uint32(10).string(message.src)
    }
    if (message.text !== '') {
      writer.uint32(18).string(message.text)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefQuote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefQuote()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.src = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.text = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefQuote {
    return {
      src: isSet(object.src) ? globalThis.String(object.src) : '',
      text: isSet(object.text) ? globalThis.String(object.text) : '',
    }
  },

  toJSON(message: HomeBriefQuote): unknown {
    const obj: any = {}
    if (message.src !== '') {
      obj.src = message.src
    }
    if (message.text !== '') {
      obj.text = message.text
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefQuote>, I>>(base?: I): HomeBriefQuote {
    return HomeBriefQuote.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefQuote>, I>>(object: I): HomeBriefQuote {
    const message = createBaseHomeBriefQuote()
    message.src = object.src ?? ''
    message.text = object.text ?? ''
    return message
  },
}

function createBaseHomeBriefCardNote(): HomeBriefCardNote {
  return { id: '', note: '', quotes: [] }
}

export const HomeBriefCardNote: MessageFns<HomeBriefCardNote> = {
  encode(message: HomeBriefCardNote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.note !== '') {
      writer.uint32(18).string(message.note)
    }
    for (const v of message.quotes) {
      HomeBriefQuote.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefCardNote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefCardNote()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.note = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quotes.push(HomeBriefQuote.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefCardNote {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      note: isSet(object.note) ? globalThis.String(object.note) : '',
      quotes: globalThis.Array.isArray(object?.quotes)
        ? object.quotes.map((e: any) => HomeBriefQuote.fromJSON(e))
        : [],
    }
  },

  toJSON(message: HomeBriefCardNote): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.note !== '') {
      obj.note = message.note
    }
    if (message.quotes?.length) {
      obj.quotes = message.quotes.map((e) => HomeBriefQuote.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefCardNote>, I>>(base?: I): HomeBriefCardNote {
    return HomeBriefCardNote.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefCardNote>, I>>(object: I): HomeBriefCardNote {
    const message = createBaseHomeBriefCardNote()
    message.id = object.id ?? ''
    message.note = object.note ?? ''
    message.quotes = object.quotes?.map((e) => HomeBriefQuote.fromPartial(e)) || []
    return message
  },
}

function createBaseHomeBriefIdeaReasoning(): HomeBriefIdeaReasoning {
  return { id: '', text: '', quotes: [] }
}

export const HomeBriefIdeaReasoning: MessageFns<HomeBriefIdeaReasoning> = {
  encode(message: HomeBriefIdeaReasoning, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.text !== '') {
      writer.uint32(18).string(message.text)
    }
    for (const v of message.quotes) {
      HomeBriefQuote.encode(v!, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefIdeaReasoning {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefIdeaReasoning()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.text = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quotes.push(HomeBriefQuote.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefIdeaReasoning {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      text: isSet(object.text) ? globalThis.String(object.text) : '',
      quotes: globalThis.Array.isArray(object?.quotes)
        ? object.quotes.map((e: any) => HomeBriefQuote.fromJSON(e))
        : [],
    }
  },

  toJSON(message: HomeBriefIdeaReasoning): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.text !== '') {
      obj.text = message.text
    }
    if (message.quotes?.length) {
      obj.quotes = message.quotes.map((e) => HomeBriefQuote.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefIdeaReasoning>, I>>(
    base?: I
  ): HomeBriefIdeaReasoning {
    return HomeBriefIdeaReasoning.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefIdeaReasoning>, I>>(
    object: I
  ): HomeBriefIdeaReasoning {
    const message = createBaseHomeBriefIdeaReasoning()
    message.id = object.id ?? ''
    message.text = object.text ?? ''
    message.quotes = object.quotes?.map((e) => HomeBriefQuote.fromPartial(e)) || []
    return message
  },
}

function createBaseHomeBriefOmission(): HomeBriefOmission {
  return { id: '', reason: '' }
}

export const HomeBriefOmission: MessageFns<HomeBriefOmission> = {
  encode(message: HomeBriefOmission, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.reason !== '') {
      writer.uint32(18).string(message.reason)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefOmission {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefOmission()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.reason = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefOmission {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      reason: isSet(object.reason) ? globalThis.String(object.reason) : '',
    }
  },

  toJSON(message: HomeBriefOmission): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.reason !== '') {
      obj.reason = message.reason
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefOmission>, I>>(base?: I): HomeBriefOmission {
    return HomeBriefOmission.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefOmission>, I>>(object: I): HomeBriefOmission {
    const message = createBaseHomeBriefOmission()
    message.id = object.id ?? ''
    message.reason = object.reason ?? ''
    return message
  },
}

function createBaseHomeBriefSectionOmission(): HomeBriefSectionOmission {
  return { section: '', reason: '' }
}

export const HomeBriefSectionOmission: MessageFns<HomeBriefSectionOmission> = {
  encode(
    message: HomeBriefSectionOmission,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.section !== '') {
      writer.uint32(10).string(message.section)
    }
    if (message.reason !== '') {
      writer.uint32(18).string(message.reason)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeBriefSectionOmission {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHomeBriefSectionOmission()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.section = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.reason = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HomeBriefSectionOmission {
    return {
      section: isSet(object.section) ? globalThis.String(object.section) : '',
      reason: isSet(object.reason) ? globalThis.String(object.reason) : '',
    }
  },

  toJSON(message: HomeBriefSectionOmission): unknown {
    const obj: any = {}
    if (message.section !== '') {
      obj.section = message.section
    }
    if (message.reason !== '') {
      obj.reason = message.reason
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HomeBriefSectionOmission>, I>>(
    base?: I
  ): HomeBriefSectionOmission {
    return HomeBriefSectionOmission.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HomeBriefSectionOmission>, I>>(
    object: I
  ): HomeBriefSectionOmission {
    const message = createBaseHomeBriefSectionOmission()
    message.section = object.section ?? ''
    message.reason = object.reason ?? ''
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isObject(value: any): boolean {
  return typeof value === 'object' && value !== null
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
